// // import axios from "axios";
// // import React, { useState } from "react";
// // import { Helmet } from "react-helmet";
// // import { RiLoader5Line } from "react-icons/ri";

// // const EsgComp = () => {
// //     const [activeESGTab, setActiveESGTab] = useState("env");

// //     const styles = {
// //         container: {
// //             fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
// //             color: "#111",
// //             backgroundColor: "#fff",
// //             lineHeight: 1.5,
// //             scrollBehavior: "smooth",
// //             overflow: 'hidden'
// //         },
// //         nav: {
// //             display: "flex",
// //             justifyContent: "space-between",
// //             alignItems: "center",
// //             padding: "1rem 5%",
// //             backgroundColor: "#fff",
// //             borderBottom: "1px solid #eaeaea",
// //             position: "sticky",
// //             top: 0,
// //             zIndex: 100,
// //         },
// //         navLogo: { display: "flex", alignItems: "center", gap: "0.75rem" },
// //         navLogoMark: {
// //             width: "32px",
// //             height: "32px",
// //             backgroundColor: "#a20000",
// //             borderRadius: "6px",
// //             display: "flex",
// //             alignItems: "center",
// //             justifyContent: "center",
// //         },
// //         navLogoMarkSvg: { width: "20px", height: "20px", fill: "white" },
// //         navLogoText: {
// //             fontWeight: 700,
// //             fontSize: "1.25rem",
// //             letterSpacing: "-0.5px",
// //             color: "#111",
// //         },
// //         navLinks: {
// //             display: "flex",
// //             gap: "clamp(1rem, 2vw, 2rem)",
// //             alignItems: "center",
// //             flexWrap: "wrap",
// //         },
// //         navLink: {
// //             textDecoration: "none",
// //             color: "#333",
// //             fontSize: "0.9rem",
// //             fontWeight: 500,
// //             transition: "color 0.2s",
// //         },
// //         navCta: {
// //             backgroundColor: "#a20000",
// //             color: "white",
// //             padding: "0.5rem 1.2rem",
// //             borderRadius: "30px",
// //             textDecoration: "none",
// //             fontWeight: 600,
// //             fontSize: "0.9rem",
// //             transition: "all 0.2s",
// //         },
// //         hero: {
// //             display: "flex",
// //             flexWrap: "wrap",
// //             justifyContent: "space-between",
// //             alignItems: "center",
// //             padding: "4rem 5%",
// //             gap: "3rem",
// //             backgroundColor: "#faf9f8",
// //             minHeight: '100vh'

// //         },
// //         heroContent: { flex: "1 1 45%" },
// //         heroEyebrow: {
// //             display: "flex",
// //             alignItems: "center",
// //             gap: "0.5rem",
// //             color: "#a20000",
// //             fontWeight: 600,
// //             fontSize: "0.8rem",
// //             textTransform: "uppercase",
// //             letterSpacing: "1px",
// //             marginBottom: "1rem",
// //         },
// //         heroEyebrowDot: {
// //             width: "8px",
// //             height: "8px",
// //             backgroundColor: "#a20000",
// //             borderRadius: "50%",
// //             display: "inline-block",
// //         },
// //         heroH1: {
// //             fontSize: "clamp(2.5rem, 6vw, 4rem)",
// //             fontFamily: "'DM Serif Display', serif",
// //             lineHeight: 1.1,
// //             marginBottom: "1rem",
// //             fontWeight: 400,
// //         },
// //         heroEm: { color: "#a20000", fontStyle: "normal" },
// //         heroDesc: {
// //             fontSize: "1.1rem",
// //             color: "#2b2b2b",
// //             maxWidth: "550px",
// //             marginBottom: "2rem",
// //         },
// //         heroActions: { display: "flex", gap: "1rem", flexWrap: "wrap" },
// //         btnPrimary: {
// //             backgroundColor: "#a20000",
// //             color: "white",
// //             padding: "0.8rem 1.8rem",
// //             borderRadius: "40px",
// //             textDecoration: "none",
// //             fontWeight: 600,
// //             display: "inline-block",
// //             transition: "all 0.2s",
// //             cursor: "pointer",
// //             border: "none",
// //         },
// //         btnOutline: {
// //             border: "2px solid #a20000",
// //             color: "#a20000",
// //             padding: "0.8rem 1.8rem",
// //             borderRadius: "40px",
// //             textDecoration: "none",
// //             fontWeight: 600,
// //             display: "inline-block",
// //             backgroundColor: "transparent",
// //             transition: "all 0.2s",
// //             cursor: "pointer",
// //         },
// //         heroStats: {
// //             flex: "1 1 35%",
// //             display: "flex",
// //             flexWrap: "wrap",
// //             justifyContent: "space-between",
// //             gap: "1.2rem",
// //         },
// //         statItem: {
// //             flex: "1 1 180px",
// //             textAlign: "center",
// //             backgroundColor: "#fff",
// //             padding: "1.2rem 0.8rem",
// //             borderRadius: "20px",
// //             boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
// //             transition: "transform 0.2s",
// //         },
// //         statNum: { fontSize: "2.2rem", fontWeight: 700, color: "#111", lineHeight: 1 },
// //         statNumSpan: { fontSize: "1rem", fontWeight: 400, color: "#666" },
// //         statLabel: { fontSize: "0.85rem", color: "#555", marginTop: "0.5rem" },
// //         // Pillars (now as a horizontal feature strip but same content)
// //         pillars: {
// //             display: "flex",
// //             flexWrap: "wrap",
// //             justifyContent: "space-between",
// //             gap: "2rem",
// //             padding: "3rem 5%",
// //             backgroundColor: "#fff",
// //             borderBottom: "1px solid #eee",
// //         },
// //         pillar: {
// //             flex: "1 1 250px",
// //             display: "flex",
// //             gap: "1rem",
// //             alignItems: "flex-start",
// //         },
// //         pillarIcon: {
// //             width: "44px",
// //             height: "44px",
// //             backgroundColor: "#f0f0f0",
// //             borderRadius: "12px",
// //             display: "flex",
// //             alignItems: "center",
// //             justifyContent: "center",
// //             flexShrink: 0,
// //         },
// //         pillarIconSvg: { width: "24px", height: "24px", stroke: "#a20000", fill: "none", strokeWidth: "1.5" },
// //         pillarTitle: { fontWeight: 700, fontSize: "1.1rem", marginBottom: "0.3rem" },
// //         pillarDesc: { fontSize: "0.9rem", color: "#555", lineHeight: 1.4 },
// //         section: { padding: "4rem 5%", maxWidth: "1400px", margin: "0 auto" },
// //         sectionEyebrow: {
// //             display: "inline-block",
// //             color: "#a20000",
// //             fontWeight: 600,
// //             fontSize: "0.8rem",
// //             textTransform: "uppercase",
// //             letterSpacing: "1px",
// //             marginBottom: "1rem",
// //         },
// //         sectionTitle: {
// //             fontSize: "clamp(1.8rem, 4vw, 2.5rem)",
// //             fontFamily: "'DM Serif Display', serif",
// //             marginBottom: "1rem",
// //             lineHeight: 1.2,
// //         },
// //         sectionLead: { fontSize: "1.1rem", color: "#444", maxWidth: "800px", marginBottom: "3rem" },
// //         // NZIA + FERX combined layout
// //         complianceDual: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(340px,1fr))", gap: "2.5rem" },
// //         complianceCard: {
// //             backgroundColor: "#faf9f8",
// //             borderRadius: "28px",
// //             padding: "2rem",
// //             transition: "transform 0.2s",
// //             height: "100%",
// //         },
// //         nziaCriteria: { display: "flex", flexDirection: "column", gap: "1rem", marginTop: "1.2rem" },
// //         criteriaItem: { display: "flex", alignItems: "center", gap: "0.8rem" },
// //         criteriaCheck: {
// //             width: "22px",
// //             height: "22px",
// //             backgroundColor: "#a20000",
// //             borderRadius: "50%",
// //             display: "inline-flex",
// //             alignItems: "center",
// //             justifyContent: "center",
// //         },
// //         criteriaCheckSvg: { width: "12px", height: "12px", stroke: "white", strokeWidth: "2", fill: "none" },
// //         ferxStatsRow: { display: "flex", gap: "1rem", marginTop: "1.5rem", flexWrap: "wrap", justifyContent: "space-between" },
// //         ferxStat: { textAlign: "center", flex: 1 },
// //         ferxStatNum: { fontSize: "1.8rem", fontWeight: 700, color: "#a20000" },
// //         ferxComplianceGrid: { display: "grid", gap: "1rem", marginTop: "1rem" },
// //         ferxComplianceItem: { borderLeft: "3px solid #a20000", paddingLeft: "1rem" },
// //         // Products (same grid)
// //         productsGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px,1fr))", gap: "2rem" },
// //         productCard: {
// //             border: "1px solid #e0e0e0",
// //             borderRadius: "24px",
// //             padding: "1.5rem",
// //             backgroundColor: "#fff",
// //             transition: "all 0.25s",
// //             boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
// //         },
// //         productBadge: { display: "inline-block", backgroundColor: "#a20000", color: "white", fontSize: "0.7rem", padding: "0.2rem 0.6rem", borderRadius: "20px", marginBottom: "1rem" },
// //         productName: { fontSize: "1.6rem", fontWeight: 700, fontFamily: "'DM Serif Display', serif" },
// //         productSub: { color: "#666", marginBottom: "1rem", fontSize: "0.9rem" },
// //         productSpec: { display: "flex", justifyContent: "space-between", borderTop: "1px solid #eee", padding: "0.7rem 0", fontSize: "0.85rem" },
// //         specKey: { color: "#555" },
// //         specVal: { fontWeight: 500, color: "#111" },
// //         highlight: { color: "#a20000", fontWeight: 700 },
// //         productFooter: { display: "flex", flexWrap: "wrap", gap: "0.5rem", marginTop: "1rem" },
// //         productTag: { fontSize: "0.7rem", backgroundColor: "#f0f0f0", padding: "0.2rem 0.6rem", borderRadius: "20px", color: "#333" },
// //         greenTag: { backgroundColor: "#e6f4ea", color: "#2e7d32" },
// //         // Traceability + certifications side by side (new layout)
// //         twoColumnLayout: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(360px,1fr))", gap: "2.5rem", marginTop: "1rem" },
// //         bomChain: { display: "flex", flexDirection: "column", gap: "1.2rem" },
// //         bomItem: { display: "flex", gap: "1rem", alignItems: "flex-start" },
// //         bomDot: { width: "28px", height: "28px", backgroundColor: "#a20000", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
// //         bomDotSvg: { width: "14px", height: "14px", stroke: "white", strokeWidth: "2", fill: "none" },
// //         complianceFlags: { display: "grid", gap: "1rem" },
// //         flagCard: { backgroundColor: "#f5f5f5", borderRadius: "16px", padding: "1.2rem", transition: "transform 0.2s" },
// //         flagTags: { display: "flex", flexWrap: "wrap", gap: "0.5rem", marginTop: "0.8rem" },
// //         flagTag: { backgroundColor: "#fff", padding: "0.2rem 0.8rem", borderRadius: "30px", fontSize: "0.75rem", border: "1px solid #ddd" },
// //         certsGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(190px,1fr))", gap: "1.2rem", marginTop: "1rem" },
// //         certCard: { backgroundColor: "#fff", border: "1px solid #eee", borderRadius: "20px", padding: "1.2rem", textAlign: "center", transition: "all 0.25s", boxShadow: "0 2px 8px rgba(0,0,0,0.04)" },
// //         certIcon: { width: "40px", height: "40px", margin: "0 auto 0.8rem", fill: "none", stroke: "#a20000", strokeWidth: "1.5" },
// //         certName: { fontWeight: 700, marginBottom: "0.3rem", fontSize: "0.9rem" },
// //         certDetail: { fontSize: "0.75rem", color: "#666" },
// //         // ESG Tabs (unchanged layout but repositioned)
// //         esgTabsContainer: { marginTop: "2rem" },
// //         esgTabs: { display: "flex", gap: "1rem", borderBottom: "2px solid #eee", marginBottom: "2rem", flexWrap: "wrap" },
// //         esgTab: { padding: "0.8rem 1.5rem", cursor: "pointer", fontWeight: 600, color: "#666", transition: "all 0.2s", borderBottom: "2px solid transparent" },
// //         activeEsgTab: { color: "#a20000", borderBottomColor: "#a20000" },
// //         esgPanel: { display: "none" },
// //         activeEsgPanel: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: "1.5rem" },
// //         esgItem: { backgroundColor: "#faf9f8", borderRadius: "20px", padding: "1.5rem", transition: "transform 0.2s", height: "100%" },
// //         esgItemNum: { fontSize: "2rem", fontWeight: 700, color: "#a20000", opacity: 0.4, marginBottom: "0.5rem" },
// //         factories: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px,1fr))", gap: "1.5rem", marginTop: "2rem" },
// //         factoryCard: { backgroundColor: "#a20000", color: "white", padding: "1.5rem", borderRadius: "24px", transition: "transform 0.2s" },
// //         factoryNum: { fontSize: "0.8rem", color: "#ffffff", marginBottom: "0.5rem" },
// //         factoryName: { fontSize: "1.6rem", fontWeight: 700, fontFamily: "'DM Serif Display', serif", marginBottom: "0.25rem" },
// //         factoryLoc: { fontSize: "0.8rem", color: "#ffffff", marginBottom: "1rem" },
// //         factoryCap: { fontWeight: 700, fontSize: "1.1rem" },
// //         ctaSection: { backgroundColor: "#a20000", color: "white", padding: "3rem 5%", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", gap: "1.5rem" },
// //         btnWhite: { backgroundColor: "white", color: "#a20000", padding: "0.8rem 1.8rem", borderRadius: "40px", textDecoration: "none", fontWeight: 600, marginRight: "1rem", transition: "all 0.2s", display: "inline-block" },
// //         btnGhost: { border: "2px solid white", color: "white", padding: "0.8rem 1.8rem", borderRadius: "40px", textDecoration: "none", fontWeight: 600, backgroundColor: "transparent", transition: "all 0.2s", display: "inline-block" },
// //         footer: { display: "flex", flexWrap: "wrap", justifyContent: "space-between", padding: "3rem 5%", backgroundColor: "#faf9f8", gap: "2rem" },
// //         footerBrand: { flex: "1 1 250px" },
// //         footerLinks: { display: "flex", flexWrap: "wrap", gap: "2rem", flex: "2 1 400px", justifyContent: "space-between" },
// //         footerCol: { display: "flex", flexDirection: "column", gap: "0.5rem" },
// //         footerColH4: { fontSize: "1rem", fontWeight: 700, marginBottom: "0.5rem" },
// //         footerLink: { textDecoration: "none", color: "#555", fontSize: "0.85rem", transition: "color 0.2s" },
// //         footerBottom: { textAlign: "center", padding: "1.5rem", borderTop: "1px solid #eee", fontSize: "0.8rem", color: "#777", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "1rem" },
// //         divider: { height: "1px", backgroundColor: "#eee", margin: "0 5%" },
// //         backToTop: {
// //             position: "fixed", bottom: "2rem", right: "2rem", backgroundColor: "#a20000", color: "white", width: "44px", height: "44px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", border: "none", boxShadow: "0 2px 12px rgba(0,0,0,0.15)", transition: "all 0.2s", zIndex: 99,

// //             // ------------------

// //             enquirySection: {
// //                 backgroundColor: "#faf9f8",
// //                 padding: "4rem 5%",
// //             },
// //             formContainer: {
// //                 maxWidth: "800px",
// //                 margin: "0 auto",
// //                 backgroundColor: "#fff",
// //                 borderRadius: "28px",
// //                 padding: "2.5rem",
// //                 boxShadow: "0 8px 24px rgba(0,0,0,0.05)",
// //             },
// //             formRow: {
// //                 display: "flex",
// //                 flexWrap: "wrap",
// //                 gap: "1.5rem",
// //                 marginBottom: "1.5rem",
// //             },
// //             formGroup: {
// //                 flex: "1 1 250px",
// //                 display: "flex",
// //                 flexDirection: "column",
// //                 gap: "0.5rem",
// //             },
// //             label: {
// //                 fontWeight: 600,
// //                 fontSize: "0.85rem",
// //                 color: "#333",
// //             },
// //             input: {
// //                 padding: "0.8rem 1rem",
// //                 border: "1px solid #ddd",
// //                 borderRadius: "16px",
// //                 fontSize: "1rem",
// //                 fontFamily: "'Inter', sans-serif",
// //                 transition: "border 0.2s",
// //                 outline: "none",
// //             },
// //             textarea: {
// //                 padding: "0.8rem 1rem",
// //                 border: "1px solid #ddd",
// //                 borderRadius: "16px",
// //                 fontSize: "1rem",
// //                 fontFamily: "'Inter', sans-serif",
// //                 resize: "vertical",
// //                 minHeight: "100px",
// //                 outline: "none",
// //             },
// //             submitBtn: {
// //                 backgroundColor: "#a20000",
// //                 color: "white",
// //                 padding: "0.8rem 2rem",
// //                 border: "none",
// //                 borderRadius: "40px",
// //                 fontWeight: 600,
// //                 fontSize: "1rem",
// //                 cursor: "pointer",
// //                 transition: "all 0.2s",
// //                 width: "100%",
// //                 marginTop: "0.5rem",
// //             },
// //             requiredStar: { color: "#a20000", marginLeft: "2px" },
// //         },
// //     };

// //     const [formData, setFormData] = useState({
// //         name: "",
// //         email: "",
// //         phone: "",
// //         companyName: "",
// //         companyDesignation: "",
// //         message: "",
// //     });
// //     const [loading, setLoading] = useState(false);

// //     const handleInputChange = (e) => {
// //         const { name, value } = e.target;
// //         setFormData((prev) => ({ ...prev, [name]: value }));
// //     };

// //     const handleSubmit = async (e) => {
// //         e.preventDefault();

// //         try {
// //             setLoading(true);
// //             let utm = localStorage.getItem('utm_data') || null;

// //             if (!formData.name || !formData.email || !formData.phone) {
// //                 alert("Please fill in all required fields (Name, Email, Phone).");
// //                 return;
// //             }

// //             formData.utm = utm

// //             await axios.post('https://gautamsolar.us/interSolar-contact', formData);

// //             alert("Thank you! Your enquiry has been received. We'll get back to you soon.");
// //             setFormData({ name: "", email: "", phone: "", message: "", companyName: '', companyDesignation: '' });

// //         } catch (er) {
// //             console.log(er)
// //         }
// //         finally {
// //             setLoading(false)
// //         }


// //     };

// //     return (

// //         <>
// //             <Helmet>

// //                 {/* =====================================================
// //       SEO
// //   ====================================================== */}

// //                 <title>
// //                     ESG & Compliance | Responsible Solar Manufacturing | Gautam Solar
// //                 </title>

// //                 <meta
// //                     name="description"
// //                     content="Explore Gautam Solar's ESG and compliance initiatives, including NZIA and FER-X compliant solar modules, traceable supply chains, responsible sourcing, emissions reduction and certified manufacturing."
// //                 />

// //                 <link
// //                     rel="canonical"
// //                     href="https://gautamsolar.com/esg/"
// //                 />

// //                 <meta
// //                     name="robots"
// //                     content="index, follow"
// //                 />

// //                 {/* Open Graph */}

// //                 <meta
// //                     property="og:title"
// //                     content="ESG & Compliance | Responsible Solar Manufacturing | Gautam Solar"
// //                 />

// //                 <meta
// //                     property="og:description"
// //                     content="Explore Gautam Solar's ESG and compliance initiatives, including NZIA and FER-X compliant solar modules, traceable supply chains, responsible sourcing, emissions reduction and certified manufacturing."
// //                 />

// //                 <meta
// //                     property="og:url"
// //                     content="https://gautamsolar.com/esg/"
// //                 />

// //                 <meta
// //                     property="og:type"
// //                     content="website"
// //                 />

// //                 <meta
// //                     property="og:site_name"
// //                     content="Gautam Solar"
// //                 />


// //                 {/* =====================================================
// //       ORGANIZATION
// //       This uses information visibly associated with
// //       Gautam Solar on the website.
// //   ====================================================== */}

// //                 <script type="application/ld+json">
// //                     {JSON.stringify({
// //                         "@context": "https://schema.org",

// //                         "@type": "Organization",

// //                         "@id": "https://gautamsolar.com/#organization",

// //                         "name": "Gautam Solar",

// //                         "url": "https://gautamsolar.com/esg/",

// //                         "telephone": "+91 93117 97248",

// //                         "email": "info@gautamsolar.com",

// //                         "address": {
// //                             "@type": "PostalAddress",
// //                             "streetAddress":
// //                                 "D-120-121, Okhla Industrial Area, Phase-1",
// //                             "addressLocality": "New Delhi",
// //                             "addressCountry": "IN"
// //                         },

// //                         "sameAs": [
// //                             "https://www.linkedin.com/company/gautam-solar",
// //                             "https://www.facebook.com/GautamSolar",
// //                             "https://twitter.com/GautamSolar",
// //                             "https://www.instagram.com/gautamsolar"
// //                         ]
// //                     })}
// //                 </script>


// //                 {/* =====================================================
// //       WEBSITE
// //   ====================================================== */}

// //                 <script type="application/ld+json">
// //                     {JSON.stringify({
// //                         "@context": "https://schema.org",

// //                         "@type": "WebSite",

// //                         "@id": "https://gautamsolar.com/#website",

// //                         "url": "https://gautamsolar.com/esg/",

// //                         "name": "Gautam Solar",

// //                         "publisher": {
// //                             "@id": "https://gautamsolar.com/#organization"
// //                         }
// //                     })}
// //                 </script>


// //                 {/* =====================================================
// //       WEBPAGE
// //   ====================================================== */}

// //                 <script type="application/ld+json">
// //                     {JSON.stringify({
// //                         "@context": "https://schema.org",

// //                         "@type": "WebPage",

// //                         "@id": "https://gautamsolar.com/esg/#webpage",

// //                         "url": "https://gautamsolar.com/esg/",

// //                         "name":
// //                             "ESG & Compliance | Responsible Solar Manufacturing | Gautam Solar",

// //                         "description":
// //                             "Gautam Solar's ESG and compliance initiatives covering NZIA and FER-X compliance, supply chain traceability, responsible sourcing, emissions reduction, certified operations and ESG commitments.",

// //                         "inLanguage": "en",

// //                         "isPartOf": {
// //                             "@id": "https://gautamsolar.com/#website"
// //                         },

// //                         "publisher": {
// //                             "@id": "https://gautamsolar.com/#organization"
// //                         },

// //                         "about": [
// //                             {
// //                                 "@type": "Thing",
// //                                 "name": "ESG and Compliance"
// //                             },
// //                             {
// //                                 "@type": "Thing",
// //                                 "name": "Responsible Solar Manufacturing"
// //                             },
// //                             {
// //                                 "@type": "Thing",
// //                                 "name": "Solar Supply Chain Traceability"
// //                             },
// //                             {
// //                                 "@type": "Thing",
// //                                 "name": "NZIA Compliance"
// //                             },
// //                             {
// //                                 "@type": "Thing",
// //                                 "name": "FER-X Compliance"
// //                             }
// //                         ],

// //                         "breadcrumb": {
// //                             "@id": "https://gautamsolar.com/esg/#breadcrumb"
// //                         }
// //                     })}
// //                 </script>


// //                 {/* =====================================================
// //       COMPLIANT MODULE RANGE
// //       These three products are visibly displayed on the
// //       ESG page.
// //   ====================================================== */}

// //                 <script type="application/ld+json">
// //                     {JSON.stringify({
// //                         "@context": "https://schema.org",

// //                         "@type": "ItemList",

// //                         "@id": "https://gautamsolar.com/esg/#module-range",

// //                         "name": "NZIA Compliant Gautam Solar Module Range",

// //                         "description":
// //                             "Gautam Solar's N-Type TOPCon module range displayed on its ESG and Compliance page.",

// //                         "numberOfItems": 3,

// //                         "itemListElement": [
// //                             {
// //                                 "@type": "ListItem",

// //                                 "position": 1,

// //                                 "item": {
// //                                     "@type": "Product",

// //                                     "name": "G12 R TOPCon",

// //                                     "brand": {
// //                                         "@type": "Brand",
// //                                         "name": "Gautam Solar"
// //                                     },

// //                                     "category": "N-Type TOPCon Solar Module",

// //                                     "description":
// //                                         "N-Type rectangular-cell TOPCon solar module with 620–640 Wp power, efficiency up to 23.69%, UL and IEC standards, and traceable non-Chinese cells.",

// //                                     "additionalProperty": [
// //                                         {
// //                                             "@type": "PropertyValue",
// //                                             "name": "Technology",
// //                                             "value": "N-Type TOPCon"
// //                                         },
// //                                         {
// //                                             "@type": "PropertyValue",
// //                                             "name": "Power",
// //                                             "value": "620–640 Wp"
// //                                         },
// //                                         {
// //                                             "@type": "PropertyValue",
// //                                             "name": "Efficiency",
// //                                             "value": "Up to 23.69%"
// //                                         },
// //                                         {
// //                                             "@type": "PropertyValue",
// //                                             "name": "Cell Size",
// //                                             "value": "105×182 mm"
// //                                         },
// //                                         {
// //                                             "@type": "PropertyValue",
// //                                             "name": "Temperature Coefficient",
// //                                             "value": "-0.29%/°C"
// //                                         },
// //                                         {
// //                                             "@type": "PropertyValue",
// //                                             "name": "Certification",
// //                                             "value": "UL & IEC Standards"
// //                                         },
// //                                         {
// //                                             "@type": "PropertyValue",
// //                                             "name": "Warranty",
// //                                             "value": "12 year / 30 year"
// //                                         }
// //                                     ]
// //                                 }
// //                             },

// //                             {
// //                                 "@type": "ListItem",

// //                                 "position": 2,

// //                                 "item": {
// //                                     "@type": "Product",

// //                                     "name": "G12 TOPCon",

// //                                     "brand": {
// //                                         "@type": "Brand",
// //                                         "name": "Gautam Solar"
// //                                     },

// //                                     "category": "N-Type TOPCon Solar Module",

// //                                     "description":
// //                                         "N-Type standard-cell TOPCon solar module with 690–720 Wp power, efficiency up to 23.20%, IEC CB standards and traceable non-Chinese cells.",

// //                                     "additionalProperty": [
// //                                         {
// //                                             "@type": "PropertyValue",
// //                                             "name": "Technology",
// //                                             "value": "N-Type TOPCon"
// //                                         },
// //                                         {
// //                                             "@type": "PropertyValue",
// //                                             "name": "Power",
// //                                             "value": "690–720 Wp"
// //                                         },
// //                                         {
// //                                             "@type": "PropertyValue",
// //                                             "name": "Efficiency",
// //                                             "value": "Up to 23.20%"
// //                                         },
// //                                         {
// //                                             "@type": "PropertyValue",
// //                                             "name": "Cell Size",
// //                                             "value": "105×210 mm"
// //                                         },
// //                                         {
// //                                             "@type": "PropertyValue",
// //                                             "name": "Temperature Coefficient",
// //                                             "value": "-0.30%/°C"
// //                                         },
// //                                         {
// //                                             "@type": "PropertyValue",
// //                                             "name": "Certification",
// //                                             "value": "IEC CB Standards"
// //                                         },
// //                                         {
// //                                             "@type": "PropertyValue",
// //                                             "name": "Warranty",
// //                                             "value": "12 year / 30 year"
// //                                         }
// //                                     ]
// //                                 }
// //                             },

// //                             {
// //                                 "@type": "ListItem",

// //                                 "position": 3,

// //                                 "item": {
// //                                     "@type": "Product",

// //                                     "name": "M10 R TOPCon",

// //                                     "brand": {
// //                                         "@type": "Brand",
// //                                         "name": "Gautam Solar"
// //                                     },

// //                                     "category": "N-Type TOPCon Solar Module",

// //                                     "description":
// //                                         "N-Type large-scale TOPCon solar module with 590–600 Wp power, efficiency up to 23.23%, UL and IEC standards and traceable non-Chinese cells.",

// //                                     "additionalProperty": [
// //                                         {
// //                                             "@type": "PropertyValue",
// //                                             "name": "Technology",
// //                                             "value": "N-Type TOPCon"
// //                                         },
// //                                         {
// //                                             "@type": "PropertyValue",
// //                                             "name": "Power",
// //                                             "value": "590–600 Wp"
// //                                         },
// //                                         {
// //                                             "@type": "PropertyValue",
// //                                             "name": "Efficiency",
// //                                             "value": "Up to 23.23%"
// //                                         },
// //                                         {
// //                                             "@type": "PropertyValue",
// //                                             "name": "Cell Size",
// //                                             "value": "91.8×182 mm"
// //                                         },
// //                                         {
// //                                             "@type": "PropertyValue",
// //                                             "name": "Temperature Coefficient",
// //                                             "value": "-0.30%/°C"
// //                                         },
// //                                         {
// //                                             "@type": "PropertyValue",
// //                                             "name": "Certification",
// //                                             "value": "UL & IEC Standards"
// //                                         },
// //                                         {
// //                                             "@type": "PropertyValue",
// //                                             "name": "Warranty",
// //                                             "value": "12 year / 30 year"
// //                                         }
// //                                     ]
// //                                 }
// //                             }
// //                         ]
// //                     })}
// //                 </script>




// //                 <script type="application/ld+json">
// //                     {JSON.stringify({
// //                         "@context": "https://schema.org",

// //                         "@type": "BreadcrumbList",

// //                         "@id": "https://gautamsolar.com/esg/#breadcrumb",

// //                         "itemListElement": [
// //                             {
// //                                 "@type": "ListItem",

// //                                 "position": 1,

// //                                 "name": "Home",

// //                                 "item": "https://gautamsolar.com/"
// //                             },

// //                             {
// //                                 "@type": "ListItem",

// //                                 "position": 2,

// //                                 "name": "ESG & Compliance",

// //                                 "item": "https://gautamsolar.com/esg/"
// //                             }
// //                         ]
// //                     })}
// //                 </script>

// //             </Helmet>
// //             <div style={styles.container}>
// //                 <style>{`
// //         .esg-comp-wrapper a, .esg-comp-wrapper button { cursor: pointer; }
// //         .esg-comp-wrapper .nav-link:hover { color: #a20000 !important; }
// //         .esg-comp-wrapper .nav-cta:hover, .esg-comp-wrapper .btn-primary:hover { background-color: #a20000 !important; transform: translateY(-2px); }
// //         .esg-comp-wrapper .btn-outline:hover { background-color: #a20000 !important; color: white !important; transform: translateY(-2px); }
// //         .esg-comp-wrapper .stat-item:hover, .esg-comp-wrapper .product-card:hover, .esg-comp-wrapper .cert-card:hover { transform: translateY(-4px); box-shadow: 0 12px 24px rgba(0,0,0,0.1); }
// //         .esg-comp-wrapper .compliance-card:hover, .esg-comp-wrapper .flag-card:hover, .esg-comp-wrapper .esg-item:hover { transform: translateY(-3px); }
// //         .esg-comp-wrapper .factory-card:hover { transform: translateY(-6px); background-color: #1a1a1a !important; }
// //         .esg-comp-wrapper .btn-white:hover { background-color: #f0f0f0 !important; transform: translateY(-2px); }
// //         .esg-comp-wrapper .btn-ghost:hover { background-color: white !important; color: #a20000 !important; }
// //         .esg-comp-wrapper .footer-link:hover { color: #a20000 !important; }
// //         .esg-comp-wrapper .back-to-top:hover { transform: scale(1.05); background-color: #a20000; }
// //         @media (max-width: 768px) {
// //           .esg-comp-wrapper nav { flex-direction: column; gap: 1rem; }
// //           .esg-comp-wrapper .hero-stats { flex-direction: column; }
// //         }
// //       `}</style>

// //                 <div
// //                     style={{
// //                         position: "relative",
// //                         overflow: "hidden",
// //                         ...styles.hero,
// //                     }}
// //                 >
// //                     <video
// //                         autoPlay
// //                         loop
// //                         muted
// //                         playsInline
// //                         style={{
// //                             position: "absolute",
// //                             top: 0,
// //                             left: 0,
// //                             width: "100%",
// //                             height: "100%",
// //                             objectFit: "cover",
// //                             zIndex: 0,
// //                             opacity: 0.3,
// //                         }}
// //                     >
// //                         <source src="/2025_Factory_Video1.mp4" type="video/mp4" />
// //                         Your browser does not support the video tag.
// //                     </video>

// //                     <div
// //                         style={{
// //                             position: "absolute",
// //                             top: 0,
// //                             left: 0,
// //                             width: "100%",
// //                             height: "100%",
// //                             backgroundColor: "rgba(0, 0, 0, 0.28)",
// //                             zIndex: 1,
// //                         }}
// //                     />

// //                     <div style={{ position: "relative", zIndex: 2, ...styles.heroContent }}>
// //                         <div style={styles.heroEyebrow}>
// //                             <span style={styles.heroEyebrowDot}></span> ESG & COMPLIANCE
// //                         </div>
// //                         <h1 style={styles.heroH1}>
// //                             Built for a<br />
// //                             <span style={styles.heroEm}>Responsible</span>
// //                             <br />Energy Future
// //                         </h1>
// //                         <p style={styles.heroDesc}>
// //                             Gautam Solar's NZIA and FER-X compliant modules deliver traceable, ESG-aligned, non-Chinese cell technology — purpose-built for Europe's new procurement era and global responsible sourcing mandates.
// //                         </p>
// //                     </div>

// //                     <div style={{ position: "relative", zIndex: 2, ...styles.heroStats }}>
// //                         <div className="stat-item" style={styles.statItem}>
// //                             <div style={styles.statNum}>5<span style={styles.statNumSpan}>GW</span></div>
// //                             <div style={styles.statLabel}>Solar Module Mfg. in India</div>
// //                         </div>
// //                         <div className="stat-item" style={styles.statItem}>
// //                             <div style={styles.statNum}>3<span style={styles.statNumSpan}>GW</span></div>
// //                             <div style={styles.statLabel}>Cell Manufacturing in India</div>
// //                         </div>
// //                         <div className="stat-item" style={styles.statItem}>
// //                             <div style={styles.statNum}>29<span style={styles.statNumSpan}>+</span></div>
// //                             <div style={styles.statLabel}>Years of Solar Experience</div>
// //                         </div>
// //                         <div className="stat-item" style={styles.statItem}>
// //                             <div style={styles.statNum}>A<span style={styles.statNumSpan}>*</span></div>
// //                             <div style={styles.statLabel}>Wood Mackenzie Grade A — H1 2025</div>
// //                         </div>
// //                     </div>
// //                 </div>

// //                 {/* Pillars (unchanged content, repositioned right after hero) */}
// //                 <div style={styles.pillars}>
// //                     <div style={styles.pillar}><div style={styles.pillarIcon}><svg viewBox="0 0 24 24" style={styles.pillarIconSvg}><path d="M9 12l2 2 4-4M12 3C7 3 3 7 3 12s4 9 9 9 9-4 9-9-4-9-9-9z" strokeLinecap="round" strokeLinejoin="round" /></svg></div><div><div style={styles.pillarTitle}>Non-Forced Labour Compliant</div><div style={styles.pillarDesc}>100% traceable Bill of Materials with no forced labour in the supply chain. UFLPA and FEOC compliant.</div></div></div>
// //                     <div style={styles.pillar}><div style={styles.pillarIcon}><svg viewBox="0 0 24 24" style={styles.pillarIconSvg}><path d="M3 3h18v18H3zM3 9h18M9 21V9" strokeLinecap="round" strokeLinejoin="round" /></svg></div><div><div style={styles.pillarTitle}>Non-Chinese Cells with Traceability</div><div style={styles.pillarDesc}>N-Type TOPCon cells manufactured in India with verified origin at every component level.</div></div></div>
// //                     <div style={styles.pillar}><div style={styles.pillarIcon}><svg viewBox="0 0 24 24" style={styles.pillarIconSvg}><path d="M12 3v4m0 10v4M3 12h4m10 0h4M6.34 6.34l2.83 2.83m5.66 5.66l2.83 2.83M6.34 17.66l2.83-2.83m5.66-5.66l2.83-2.83" strokeLinecap="round" strokeLinejoin="round" /></svg></div><div><div style={styles.pillarTitle}>ESG Aligned Factory & Supply Chain</div><div style={styles.pillarDesc}>Reduced Scope 1, 2 & 3 emissions. ISO 9001, 14001 & 45001 certified operations across all plants.</div></div></div>
// //                 </div>

// //                 {/* NZIA + FER-X combined (new layout) */}
// //                 <section id="nzia-ferx" style={styles.section}>
// //                     <span style={styles.sectionEyebrow}>EU Regulation & Italy's FER-X</span>
// //                     <h2 style={styles.sectionTitle}>NZIA & FER‑X <span style={styles.heroEm}>Compliance Hub</span></h2>
// //                     <p style={styles.sectionLead}>One integrated standard for European resilience — Gautam Solar meets both NZIA non‑price criteria and Italy's FER‑X requirements for non‑Chinese components.</p>
// //                     <div style={styles.complianceDual}>
// //                         <div className="compliance-card" style={styles.complianceCard}>
// //                             <h3>Net Zero Industry Act (NZIA)</h3>
// //                             <p>Adopted May 2024. EU member states apply non-price criteria – resilience, sustainability, responsible business conduct. Tolerance for price differences up to 20%.</p>
// //                             <div style={styles.nziaCriteria}>
// //                                 {["Resilience Contribution — non-Chinese supply chain", "Sustainability — reduced Scope 1,2,3, ISO 14001", "Responsible Business Conduct — labour compliance", "Supply Chain Traceability — 100% BOM traceable", "ESG Disclosure & audit documentation", "Recyclable materials & end-of-life programs"].map(text => (
// //                                     <div key={text} style={styles.criteriaItem}><div style={styles.criteriaCheck}><svg viewBox="0 0 12 12" style={styles.criteriaCheckSvg}><polyline points="2,6 5,9 10,3" /></svg></div><span>{text}</span></div>
// //                                 ))}
// //                             </div>
// //                         </div>
// //                         <div className="compliance-card" style={styles.complianceCard}>
// //                             <h3>🇮🇹 FER‑X (Italy NZIA implementation)</h3>
// //                             <p>For projects >1 MW: mandatory non-Chinese modules. First auction awarded 1.1 GW at €66.38/MWh. Gautam Solar qualifies with 4+ non-Chinese components.</p>
// //                             <div style={styles.ferxStatsRow}>
// //                                 <div style={styles.ferxStat}><div style={styles.ferxStatNum}>1.1 GW</div><div>awarded</div></div>
// //                                 <div style={styles.ferxStat}><div style={styles.ferxStatNum}>88</div><div>projects</div></div>
// //                                 <div style={styles.ferxStat}><div style={styles.ferxStatNum}>4+</div><div>non‑Chinese components</div></div>
// //                             </div>
// //                             <div style={styles.ferxComplianceGrid}>
// //                                 <div style={styles.ferxComplianceItem}><h5>Solar Cells</h5><p>N-Type TOPCon cells made in India (3GW Malanpur).</p></div>
// //                                 <div style={styles.ferxComplianceItem}><h5>Module Assembly</h5><p>5GW capacity Haridwar & Bhiwani, IEC/UL certified.</p></div>
// //                                 <div style={styles.ferxComplianceItem}><h5>Full BOM documentation</h5><p>Cell, glass, frame, encapsulant – traceable & available for GSE.</p></div>
// //                             </div>
// //                         </div>
// //                     </div>
// //                 </section>
// //                 <div style={styles.divider}></div>

// //                 {/* Products (unchanged) */}
// //                 <section id="products" style={styles.section}>
// //                     <span style={{ ...styles.sectionEyebrow, color: "#a20000" }}>NZIA & FER-X Compliant Modules</span>
// //                     <h2 style={styles.sectionTitle}>Our Compliant <span style={{ color: "#a20000" }}>Module Range</span></h2>
// //                     <p style={styles.sectionLead}>Three high-performance N-Type TOPCon series, all NZIA-compliant, IEC/UL certified, and fully traceable.</p>
// //                     <div style={styles.productsGrid}>
// //                         {[["G12 R TOPCon", "N-Type · Rectangular Cell · 620–640 Wp", "Up to 23.69%", "620 – 640 Wp", "N-Type TOPCon 105×182mm", "−0.29%/°C", "UL & IEC Standards", "12 yr / 30 yr", "FER-X Eligible"],
// //                         ["G12 TOPCon", "N-Type · Standard Cell · 690–720 Wp", "Up to 23.20%", "690 – 720 Wp", "N-Type TOPCon 105×210mm", "−0.30%/°C", "IEC CB Standards", "12 yr / 30 yr", "High-Power"],
// //                         ["M10 R TOPCon", "N-Type · Large-Scale · 590–600 Wp", "Up to 23.23%", "590 – 600 Wp", "N-Type TOPCon 91.8×182mm", "−0.30%/°C", "UL & IEC Standards", "12 yr / 30 yr", "Utility-Scale"]].map((prod, i) => (
// //                             <div key={i} className="product-card" style={styles.productCard}>
// //                                 <div style={styles.productBadge}>NZIA Compliant</div>
// //                                 <div style={styles.productName}>{prod[0]}</div><div style={styles.productSub}>{prod[1]}</div>
// //                                 <div style={styles.productSpec}><span style={styles.specKey}>Efficiency</span><span style={{ ...styles.specVal, ...styles.highlight }}>{prod[2]}</span></div>
// //                                 <div style={styles.productSpec}><span>Power</span><span>{prod[3]}</span></div>
// //                                 <div style={styles.productSpec}><span>Cells</span><span>{prod[4]}</span></div>
// //                                 <div style={styles.productSpec}><span>Temp Coeff</span><span>{prod[5]}</span></div>
// //                                 <div style={styles.productSpec}><span>Certification</span><span>{prod[6]}</span></div>
// //                                 <div style={styles.productSpec}><span>Warranty</span><span>{prod[7]}</span></div>
// //                                 <div style={styles.productFooter}><span style={{ ...styles.productTag, ...styles.greenTag }}>Non-Chinese Cells</span><span style={styles.productTag}>Traceable BOM</span><span style={styles.productTag}>{prod[8]}</span></div>
// //                             </div>
// //                         ))}
// //                     </div>
// //                 </section>

// //                 {/* Traceability + Certifications side by side (new layout) */}
// //                 <section id="trace-cert" style={styles.section}>
// //                     <span style={styles.sectionEyebrow}>Trust & Transparency</span>
// //                     <h2 style={styles.sectionTitle}>Traceability <span style={styles.heroEm}>meets</span> Global Certification</h2>
// //                     <p style={styles.sectionLead}>100% component‑level traceability + industry‑leading certifications: bankability for every project.</p>
// //                     <div style={styles.twoColumnLayout}>
// //                         <div>
// //                             <h3 style={{ fontFamily: "'DM Serif Display', serif", marginBottom: "1.2rem" }}>Bill of Materials – fully traceable</h3>
// //                             <div style={styles.bomChain}>
// //                                 {[{ title: "Solar Cell", desc: "N-Type TOPCon cells made in India. Non-Chinese, non-Xinjiang." }, { title: "Glass", desc: "2.0mm AR coated, high transmission." }, { title: "EVA/POE Encapsulant", desc: "PID Free, UV resistant, batch traceable." }, { title: "Junction Box", desc: "IP68, MC4 compatible." }, { title: "Frame & Ribbon", desc: "Anodised aluminium, full material certification." }].map((item, i) => (
// //                                     <div key={i} style={styles.bomItem}><div style={styles.bomDot}><svg viewBox="0 0 14 14" style={styles.bomDotSvg}>{i === 0 ? <circle cx="7" cy="7" r="4" /> : i === 1 ? <rect x="2" y="2" width="10" height="10" rx="1" /> : <path d="M2 2h10v10H2z" />}</svg></div><div><h5>{item.title}</h5><p>{item.desc}</p></div></div>
// //                                 ))}
// //                             </div>
// //                         </div>
// //                         <div>
// //                             <h3 style={{ fontFamily: "'DM Serif Display', serif", marginBottom: "1.2rem" }}>Compliance & Certifications</h3>
// //                             <div style={styles.complianceFlags}>
// //                                 <div className="flag-card" style={styles.flagCard}><h5>🇺🇸 UFLPA & FEOC</h5><div style={styles.flagTags}><span style={styles.flagTag}>UFLPA Compliant</span><span style={styles.flagTag}>FEOC Compliant</span><span style={styles.flagTag}>Supply Chain Docs</span></div></div>
// //                                 <div className="flag-card" style={styles.flagCard}><h5>🇪🇺 Europe ESG</h5><div style={styles.flagTags}><span style={styles.flagTag}>Due Diligence</span><span style={styles.flagTag}>Carbon Reporting</span><span style={styles.flagTag}>Non-Forced Labour</span></div></div>
// //                             </div>
// //                             <div style={styles.certsGrid}>
// //                                 {[{ name: "Kiwa PVEL Top Performer", detail: "12th Edition · 2026" }, { name: "Wood Mackenzie Grade A", detail: "Global Top 30, H1 2025" }, { name: "IEC & IEC CB", detail: "Intl. Standards" }, { name: "UL Listed", detail: "cULus Safety" }, { name: "CRISIL A-/Stable", detail: "A2+ rating" }, { name: "CE Certified", detail: "European Conformity" }, { name: "ISO 9001/14001/45001", detail: "Q&E&OH Management" }, { name: "SGS Certified", detail: "3rd party inspection" }].map((cert, i) => (
// //                                     <div key={i} className="cert-card" style={styles.certCard}><div style={styles.certIcon}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" /></svg></div><div style={styles.certName}>{cert.name}</div><div style={styles.certDetail}>{cert.detail}</div></div>
// //                                 ))}
// //                             </div>
// //                         </div>
// //                     </div>
// //                 </section>
// //                 <div style={styles.divider}></div>

// //                 {/* ESG Framework (unchanged tabs, same data) */}
// //                 <section id="esg" style={styles.section}>
// //                     <span style={styles.sectionEyebrow}>ESG Framework</span>
// //                     <h2 style={styles.sectionTitle}>
// //                         Our <span style={styles.heroEm}>Environmental, Social &amp;</span>
// //                         <br />Governance Commitments
// //                     </h2>
// //                     <p style={styles.sectionLead}>
// //                         Built into operations, supply chain, and manufacturing — not just reporting.
// //                     </p>

// //                     <div style={styles.esgTabsContainer}>
// //                         {/* Tabs (unchanged) */}
// //                         <div style={styles.esgTabs}>
// //                             <div
// //                                 onClick={() => setActiveESGTab("env")}
// //                                 className="esg-tab"
// //                                 style={{
// //                                     ...styles.esgTab,
// //                                     ...(activeESGTab === "env" ? styles.activeEsgTab : {}),
// //                                 }}
// //                             >
// //                                 Environmental
// //                             </div>
// //                             <div
// //                                 onClick={() => setActiveESGTab("soc")}
// //                                 className="esg-tab"
// //                                 style={{
// //                                     ...styles.esgTab,
// //                                     ...(activeESGTab === "soc" ? styles.activeEsgTab : {}),
// //                                 }}
// //                             >
// //                                 Social
// //                             </div>
// //                             <div
// //                                 onClick={() => setActiveESGTab("gov")}
// //                                 className="esg-tab"
// //                                 style={{
// //                                     ...styles.esgTab,
// //                                     ...(activeESGTab === "gov" ? styles.activeEsgTab : {}),
// //                                 }}
// //                             >
// //                                 Governance
// //                             </div>
// //                         </div>

// //                         {/* Environmental Panel – Vertical List Layout */}
// //                         <div
// //                             style={
// //                                 activeESGTab === "env"
// //                                     ? {
// //                                         display: "flex",
// //                                         flexDirection: "column",
// //                                         gap: "1.25rem",
// //                                         marginTop: "2rem",
// //                                     }
// //                                     : { display: "none" }
// //                             }
// //                         >
// //                             {[
// //                                 {
// //                                     title: "Scope 1,2,3 Emissions Reduction",
// //                                     desc: "Active programmes to reduce direct, indirect, and value chain emissions across all four manufacturing facilities.",
// //                                 },
// //                                 {
// //                                     title: "ISO 14001 Certified",
// //                                     desc: "Environmental Management System certified across Haridwar, Bhiwani, and Malanpur manufacturing sites.",
// //                                 },
// //                                 {
// //                                     title: "Recyclable Materials",
// //                                     desc: "Module design incorporates recyclable glass, aluminium frames, and encapsulants, with structured end-of-life take-back and recycling programs.",
// //                                 },
// //                                 {
// //                                     title: "ESG Reporting",
// //                                     desc: "Comprehensive sustainability disclosures available including environmental performance data aligned with GRI and SASB frameworks.",
// //                                 },
// //                                 {
// //                                     title: "Carbon Footprint Disclosure",
// //                                     desc: "Product-level and facility-level carbon reporting available to support developer and lender ESG reporting obligations.",
// //                                 },
// //                                 {
// //                                     title: "Responsible Sourcing",
// //                                     desc: "All raw materials procured with verified origin documentation, prioritising suppliers with environmental certification.",
// //                                 },
// //                             ].map((item, idx) => (
// //                                 <div
// //                                     key={idx}
// //                                     style={{
// //                                         display: "flex",
// //                                         alignItems: "flex-start",
// //                                         gap: "1.5rem",
// //                                         backgroundColor: "#faf9f8",
// //                                         borderRadius: "20px",
// //                                         padding: "1.2rem 1.5rem",
// //                                         transition: "transform 0.2s",
// //                                     }}
// //                                     className="esg-item-row"
// //                                 >
// //                                     <div
// //                                         style={{
// //                                             fontSize: "2.5rem",
// //                                             fontWeight: 700,
// //                                             color: "#a20000",
// //                                             opacity: 0.5,
// //                                             lineHeight: 1,
// //                                             minWidth: "60px",
// //                                         }}
// //                                     >
// //                                         {String(idx + 1).padStart(2, "0")}
// //                                     </div>
// //                                     <div style={{ flex: 1 }}>
// //                                         <h4 style={{ fontSize: "1.2rem", marginBottom: "0.4rem" }}>
// //                                             {item.title}
// //                                         </h4>
// //                                         <p style={{ color: "#555", lineHeight: 1.4, margin: 0 }}>
// //                                             {item.desc}
// //                                         </p>
// //                                     </div>
// //                                 </div>
// //                             ))}
// //                         </div>

// //                         {/* Social Panel – Vertical List Layout */}
// //                         <div
// //                             style={
// //                                 activeESGTab === "soc"
// //                                     ? {
// //                                         display: "flex",
// //                                         flexDirection: "column",
// //                                         gap: "1.25rem",
// //                                         marginTop: "2rem",
// //                                     }
// //                                     : { display: "none" }
// //                             }
// //                         >
// //                             {[
// //                                 {
// //                                     title: "Non-Forced Labour BOM",
// //                                     desc: "Complete supply chain audit confirms no forced, bonded, or child labour at any tier — UFLPA and FEOC compliant.",
// //                                 },
// //                                 {
// //                                     title: "ISO 45001 OHS",
// //                                     desc: "Worker safety management system certified across all manufacturing facilities.",
// //                                 },
// //                                 {
// //                                     title: "Community Development",
// //                                     desc: "Active CSR programmes including medical equipment donation to AIIMS, health camps, clean mobility, and education initiatives across India.",
// //                                 },
// //                                 {
// //                                     title: "Women Leadership",
// //                                     desc: "Championing gender diversity in solar manufacturing, with women leadership recognised at national industry level.",
// //                                 },
// //                                 {
// //                                     title: "Make in India Jobs",
// //                                     desc: "Manufacturing 100% in India, directly generating thousands of skilled and semi-skilled jobs in Uttarakhand, Haryana, and Madhya Pradesh.",
// //                                 },
// //                                 {
// //                                     title: "Supplier Labour Audits",
// //                                     desc: "Regular social compliance audits conducted across the supply chain to maintain standards at every tier.",
// //                                 },
// //                             ].map((item, idx) => (
// //                                 <div
// //                                     key={idx}
// //                                     style={{
// //                                         display: "flex",
// //                                         alignItems: "flex-start",
// //                                         gap: "1.5rem",
// //                                         backgroundColor: "#faf9f8",
// //                                         borderRadius: "20px",
// //                                         padding: "1.2rem 1.5rem",
// //                                         transition: "transform 0.2s",
// //                                     }}
// //                                     className="esg-item-row"
// //                                 >
// //                                     <div
// //                                         style={{
// //                                             fontSize: "2.5rem",
// //                                             fontWeight: 700,
// //                                             color: "#a20000",
// //                                             opacity: 0.5,
// //                                             lineHeight: 1,
// //                                             minWidth: "60px",
// //                                         }}
// //                                     >
// //                                         {String(idx + 1).padStart(2, "0")}
// //                                     </div>
// //                                     <div style={{ flex: 1 }}>
// //                                         <h4 style={{ fontSize: "1.2rem", marginBottom: "0.4rem" }}>
// //                                             {item.title}
// //                                         </h4>
// //                                         <p style={{ color: "#555", lineHeight: 1.4, margin: 0 }}>
// //                                             {item.desc}
// //                                         </p>
// //                                     </div>
// //                                 </div>
// //                             ))}
// //                         </div>

// //                         {/* Governance Panel – Vertical List Layout */}
// //                         <div
// //                             style={
// //                                 activeESGTab === "gov"
// //                                     ? {
// //                                         display: "flex",
// //                                         flexDirection: "column",
// //                                         gap: "1.25rem",
// //                                         marginTop: "2rem",
// //                                     }
// //                                     : { display: "none" }
// //                             }
// //                         >
// //                             {[
// //                                 {
// //                                     title: "CRISIL A-/Stable",
// //                                     desc: "Independent credit rating from S&P Global's CRISIL confirms strong financial health and low counterparty risk for long-term project partners.",
// //                                 },
// //                                 {
// //                                     title: "Anti-Corruption",
// //                                     desc: "Documented anti-bribery and anti-corruption policies governing all business operations, procurement, and external partnerships.",
// //                                 },
// //                                 {
// //                                     title: "ISO 9001",
// //                                     desc: "Certified quality management system ensuring consistent product standards, audit trails, and continuous improvement processes.",
// //                                 },
// //                                 {
// //                                     title: "Procurement Transparency",
// //                                     desc: "Full supply chain documentation available for lender, auditor, and procurement team review — enabling due diligence at every project stage.",
// //                                 },
// //                                 {
// //                                     title: "Creditworthy Partner",
// //                                     desc: "Ariel Re insured and CreditSafe rated B (Low Risk), providing bankability assurance for project finance and EPC partnerships.",
// //                                 },
// //                                 {
// //                                     title: "Regulatory Compliance",
// //                                     desc: "Fully compliant with GDPR, CCPA, Indian IT Act, and all applicable data protection and business conduct regulations.",
// //                                 },
// //                             ].map((item, idx) => (
// //                                 <div
// //                                     key={idx}
// //                                     style={{
// //                                         display: "flex",
// //                                         alignItems: "flex-start",
// //                                         gap: "1.5rem",
// //                                         backgroundColor: "#faf9f8",
// //                                         borderRadius: "20px",
// //                                         padding: "1.2rem 1.5rem",
// //                                         transition: "transform 0.2s",
// //                                     }}
// //                                     className="esg-item-row"
// //                                 >
// //                                     <div
// //                                         style={{
// //                                             fontSize: "2.5rem",
// //                                             fontWeight: 700,
// //                                             color: "#a20000",
// //                                             opacity: 0.5,
// //                                             lineHeight: 1,
// //                                             minWidth: "60px",
// //                                         }}
// //                                     >
// //                                         {String(idx + 1).padStart(2, "0")}
// //                                     </div>
// //                                     <div style={{ flex: 1 }}>
// //                                         <h4 style={{ fontSize: "1.2rem", marginBottom: "0.4rem" }}>
// //                                             {item.title}
// //                                         </h4>
// //                                         <p style={{ color: "#555", lineHeight: 1.4, margin: 0 }}>
// //                                             {item.desc}
// //                                         </p>
// //                                     </div>
// //                                 </div>
// //                             ))}
// //                         </div>
// //                     </div>
// //                 </section>

// //                 {/* Factories, CTA, Footer unchanged */}
// //                 <section id="factories" style={styles.section}>
// //                     <span style={{ ...styles.sectionEyebrow, color: "#a20000" }}>Manufacturing Footprint</span>
// //                     <h2 style={styles.sectionTitle}>Made in <span style={{ color: "#a20000" }}>India. Only.</span></h2>
// //                     <p style={styles.sectionLead}>Four factories. 5 GW module capacity. 3 GW cell manufacturing. 2 GW ingot & wafer by 2028.</p>
// //                     <div style={styles.factories}>
// //                         {[["Haridwar", "Plot 67–70, Sec 8A, SIDCUL, UK", "Solar Module"], ["Bhiwani", "7KM Milestone, Tosham Road, Haryana", "Solar Module"], ["Malanpur", "Malanpur Ind. Area, Nr. Gwalior, M.P.", "3 GW Cell"], ["Narmadapuram", "Bhopal, Madhya Pradesh", "2 GW Ingot"]].map((fac, i) => (
// //                             <div key={i} className="factory-card" style={{ ...styles.factoryCard }}><div style={styles.factoryNum}>Factory 0{i + 1}{i === 3 ? " — Upcoming" : ""}</div><div style={styles.factoryName}>{fac[0]}</div><div style={styles.factoryLoc}>{fac[1]}</div><div style={styles.factoryCap}>{fac[2]}</div></div>
// //                         ))}
// //                     </div>
// //                 </section>

              

// //                 <section id="enquiry" style={{ backgroundColor: "#faf9f8", padding: "4rem 5%" }}>
// //                     <div style={{ maxWidth: "800px", margin: "0 auto", backgroundColor: "#fff", borderRadius: "28px", padding: "2.5rem", boxShadow: "0 8px 24px rgba(0,0,0,0.05)" }}>
// //                         <span style={{ ...styles.sectionEyebrow, color: "#a20000", display: "block", textAlign: "center" }}>
// //                             Request Information
// //                         </span>
// //                         <h2 style={{ ...styles.sectionTitle, textAlign: "center", fontSize: "clamp(1.6rem, 4vw, 2rem)" }}>
// //                             Let’s Discuss Your <span style={styles.heroEm}>Project Needs</span>
// //                         </h2>
// //                         <p style={{ textAlign: "center", color: "#555", marginBottom: "2rem" }}>
// //                             Fill out the form below and our ESG compliance team will get back to you.
// //                         </p>

// //                         <form onSubmit={handleSubmit}>
// //                             {/* Row 1: Name + Email */}
// //                             <div
// //                                 style={{
// //                                     display: "flex",
// //                                     flexWrap: "wrap",
// //                                     gap: "1.5rem",
// //                                     marginBottom: "1.5rem",
// //                                 }}
// //                             >
// //                                 <div
// //                                     style={{
// //                                         flex: "1 1 250px",
// //                                         display: "flex",
// //                                         flexDirection: "column",
// //                                         gap: "0.5rem",
// //                                     }}
// //                                 >
// //                                     <label
// //                                         style={{ fontWeight: 600, fontSize: "0.85rem", color: "#333" }}
// //                                     >
// //                                         Full Name <span style={{ color: "#a20000" }}>*</span>
// //                                     </label>
// //                                     <input
// //                                         type="text"
// //                                         name="name"
// //                                         value={formData.name}
// //                                         onChange={handleInputChange}
// //                                         style={{
// //                                             padding: "0.8rem 1rem",
// //                                             border: "1px solid #ddd",
// //                                             borderRadius: "16px",
// //                                             fontSize: "1rem",
// //                                             fontFamily: "'Inter', sans-serif",
// //                                             outline: "none",
// //                                         }}
// //                                         placeholder="Name"
// //                                         required
// //                                     />
// //                                 </div>
// //                                 <div
// //                                     style={{
// //                                         flex: "1 1 250px",
// //                                         display: "flex",
// //                                         flexDirection: "column",
// //                                         gap: "0.5rem",
// //                                     }}
// //                                 >
// //                                     <label
// //                                         style={{ fontWeight: 600, fontSize: "0.85rem", color: "#333" }}
// //                                     >
// //                                         Email Address <span style={{ color: "#a20000" }}>*</span>
// //                                     </label>
// //                                     <input
// //                                         type="email"
// //                                         name="email"
// //                                         value={formData.email}
// //                                         onChange={handleInputChange}
// //                                         style={{
// //                                             padding: "0.8rem 1rem",
// //                                             border: "1px solid #ddd",
// //                                             borderRadius: "16px",
// //                                             fontSize: "1rem",
// //                                             fontFamily: "'Inter', sans-serif",
// //                                             outline: "none",
// //                                         }}
// //                                         placeholder="Email"
// //                                         required
// //                                     />
// //                                 </div>
// //                             </div>

// //                             {/* Row 2: Phone + Company */}
// //                             <div
// //                                 style={{
// //                                     display: "flex",
// //                                     flexWrap: "wrap",
// //                                     gap: "1.5rem",
// //                                     marginBottom: "1.5rem",
// //                                 }}
// //                             >
// //                                 <div
// //                                     style={{
// //                                         flex: "1 1 250px",
// //                                         display: "flex",
// //                                         flexDirection: "column",
// //                                         gap: "0.5rem",
// //                                     }}
// //                                 >
// //                                     <label
// //                                         style={{ fontWeight: 600, fontSize: "0.85rem", color: "#333" }}
// //                                     >
// //                                         Phone Number <span style={{ color: "#a20000" }}>*</span>
// //                                     </label>
// //                                     <input
// //                                         type="tel"
// //                                         name="phone"
// //                                         value={formData.phone}
// //                                         onChange={handleInputChange}
// //                                         style={{
// //                                             padding: "0.8rem 1rem",
// //                                             border: "1px solid #ddd",
// //                                             borderRadius: "16px",
// //                                             fontSize: "1rem",
// //                                             fontFamily: "'Inter', sans-serif",
// //                                             outline: "none",
// //                                         }}
// //                                         placeholder="Phone Number"
// //                                         required
// //                                     />
// //                                 </div>
// //                                 <div
// //                                     style={{
// //                                         flex: "1 1 250px",
// //                                         display: "flex",
// //                                         flexDirection: "column",
// //                                         gap: "0.5rem",
// //                                     }}
// //                                 >
// //                                     <label
// //                                         style={{ fontWeight: 600, fontSize: "0.85rem", color: "#333" }}
// //                                     >
// //                                         Company / Organisation
// //                                     </label>
// //                                     <input
// //                                         type="text"
// //                                         name="companyName"
// //                                         value={formData.companyName}
// //                                         onChange={handleInputChange}
// //                                         style={{
// //                                             padding: "0.8rem 1rem",
// //                                             border: "1px solid #ddd",
// //                                             borderRadius: "16px",
// //                                             fontSize: "1rem",
// //                                             fontFamily: "'Inter', sans-serif",
// //                                             outline: "none",
// //                                         }}
// //                                         required
// //                                         placeholder="Company Name"
// //                                     />
// //                                 </div>
// //                             </div>

// //                             {/* NEW ROW: Company Designation (EPC / Dealer / Distributor / Other) */}
// //                             <div
// //                                 style={{
// //                                     display: "flex",
// //                                     flexWrap: "wrap",
// //                                     gap: "1.5rem",
// //                                     marginBottom: "1.5rem",
// //                                 }}
// //                             >
// //                                 <div
// //                                     style={{
// //                                         flex: "1 1 250px",
// //                                         display: "flex",
// //                                         flexDirection: "column",
// //                                         gap: "0.5rem",
// //                                     }}
// //                                 >
// //                                     <label
// //                                         style={{ fontWeight: 600, fontSize: "0.85rem", color: "#333" }}
// //                                     >
// //                                         Company Designation
// //                                     </label>
// //                                     <select
// //                                         name="companyDesignation"
// //                                         value={formData.companyDesignation}
// //                                         onChange={handleInputChange}
// //                                         style={{
// //                                             padding: "0.8rem 1rem",
// //                                             border: "1px solid #ddd",
// //                                             borderRadius: "16px",
// //                                             fontSize: "1rem",
// //                                             fontFamily: "'Inter', sans-serif",
// //                                             backgroundColor: "#fff",
// //                                             outline: "none",
// //                                             cursor: "pointer",
// //                                         }}
// //                                         required
// //                                     >
// //                                         <option value="">Select designation</option>
// //                                         <option value="EPC">EPC</option>
// //                                         <option value="Dealer">Dealer</option>
// //                                         <option value="Distributor">Distributor</option>
// //                                         <option value="Other">Other</option>
// //                                     </select>
// //                                 </div>

// //                             </div>

// //                             {/* Row: Short Message */}
// //                             <div
// //                                 style={{
// //                                     display: "flex",
// //                                     flexDirection: "column",
// //                                     gap: "0.5rem",
// //                                     marginBottom: "1.5rem",
// //                                 }}
// //                             >
// //                                 <label
// //                                     style={{ fontWeight: 600, fontSize: "0.85rem", color: "#333" }}
// //                                 >
// //                                     Short Message
// //                                 </label>
// //                                 <textarea
// //                                     name="message"
// //                                     value={formData.message}
// //                                     onChange={handleInputChange}
// //                                     style={{
// //                                         padding: "0.8rem 1rem",
// //                                         border: "1px solid #ddd",
// //                                         borderRadius: "16px",
// //                                         fontSize: "1rem",
// //                                         fontFamily: "'Inter', sans-serif",
// //                                         resize: "vertical",
// //                                         minHeight: "100px",
// //                                         outline: "none",
// //                                     }}
// //                                     placeholder="Tell us about your project, required modules, or compliance documentation needs..."
// //                                 />
// //                             </div>

// //                             <button
// //                                 type="submit"
// //                                 disabled={loading}  // optional: prevent double submission
// //                                 style={{
// //                                     backgroundColor: "#a20000",
// //                                     color: "white",
// //                                     padding: "0.8rem 2rem",
// //                                     border: "none",
// //                                     borderRadius: "40px",
// //                                     fontWeight: 600,
// //                                     fontSize: "1rem",
// //                                     cursor: loading ? "not-allowed" : "pointer",
// //                                     transition: "all 0.2s",
// //                                     width: "100%",
// //                                     marginTop: "0.5rem",
// //                                     opacity: loading ? 0.7 : 1,
// //                                 }}
// //                             >
// //                                 {loading ? (
// //                                     <RiLoader5Line size={30} style={{ animation: "spin 1s linear infinite" }} />
// //                                 ) : (
// //                                     'Send Enquiry →'
// //                                 )}
// //                             </button>

// //                             <style>{`
// //     @keyframes spin {
// //         0% { transform: rotate(0deg); }
// //         100% { transform: rotate(360deg); }
// //     }
// // `}</style>
// //                         </form>
// //                     </div>
// //                 </section>


// //             </div>
// //         </>

// //     );
// // };

// // export default EsgComp;

// import axios from "axios";
// import React, { useState } from "react";
// import { Helmet } from "react-helmet";
// import { RiLoader5Line } from "react-icons/ri";

// const EsgComp = () => {
//     const [activeESGTab, setActiveESGTab] = useState("env");

//     const styles = {
//         container: {
//             fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
//             color: "#111",
//             backgroundColor: "#fff",
//             lineHeight: 1.5,
//             scrollBehavior: "smooth",
//             overflow: 'hidden'
//         },
//         nav: {
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             padding: "1rem 5%",
//             backgroundColor: "#fff",
//             borderBottom: "1px solid #eaeaea",
//             position: "sticky",
//             top: 0,
//             zIndex: 100,
//         },
//         navLogo: { display: "flex", alignItems: "center", gap: "0.75rem" },
//         navLogoMark: {
//             width: "32px",
//             height: "32px",
//             backgroundColor: "#a20000",
//             borderRadius: "6px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//         },
//         navLogoMarkSvg: { width: "20px", height: "20px", fill: "white" },
//         navLogoText: {
//             fontWeight: 700,
//             fontSize: "1.25rem",
//             letterSpacing: "-0.5px",
//             color: "#111",
//         },
//         navLinks: {
//             display: "flex",
//             gap: "clamp(1rem, 2vw, 2rem)",
//             alignItems: "center",
//             flexWrap: "wrap",
//         },
//         navLink: {
//             textDecoration: "none",
//             color: "#333",
//             fontSize: "0.9rem",
//             fontWeight: 500,
//             transition: "color 0.2s",
//         },
//         navCta: {
//             backgroundColor: "#a20000",
//             color: "white",
//             padding: "0.5rem 1.2rem",
//             borderRadius: "30px",
//             textDecoration: "none",
//             fontWeight: 600,
//             fontSize: "0.9rem",
//             transition: "all 0.2s",
//         },
//         hero: {
//             display: "flex",
//             flexWrap: "wrap",
//             justifyContent: "space-between",
//             alignItems: "center",
//             padding: "4rem 5%",
//             gap: "3rem",
//             backgroundColor: "#faf9f8",
//             minHeight: '100vh',
//             position: "relative",
//             overflow: "hidden",
//         },
//         // Left column of hero (content + stats stacked)
//         heroLeft: {
//             flex: "1 1 480px",
//             display: "flex",
//             flexDirection: "column",
//             gap: "2.5rem",
//             position: "relative",
//             zIndex: 2,
//         },
//         heroContent: { width: "100%" },
//         heroEyebrow: {
//             display: "flex",
//             alignItems: "center",
//             gap: "0.5rem",
//             color: "#a20000",
//             fontWeight: 600,
//             fontSize: "0.8rem",
//             textTransform: "uppercase",
//             letterSpacing: "1px",
//             marginBottom: "1rem",
//         },
//         heroEyebrowDot: {
//             width: "8px",
//             height: "8px",
//             backgroundColor: "#a20000",
//             borderRadius: "50%",
//             display: "inline-block",
//         },
//         heroH1: {
//             fontSize: "clamp(2.5rem, 6vw, 4rem)",
//             fontFamily: "'DM Serif Display', serif",
//             lineHeight: 1.1,
//             marginBottom: "1rem",
//             fontWeight: 400,
//         },
//         heroEm: { color: "#a20000", fontStyle: "normal" },
//         heroDesc: {
//             fontSize: "1.1rem",
//             color: "#2b2b2b",
//             maxWidth: "550px",
//             marginBottom: "2rem",
//         },
//         heroActions: { display: "flex", gap: "1rem", flexWrap: "wrap" },
//         btnPrimary: {
//             backgroundColor: "#a20000",
//             color: "white",
//             padding: "0.8rem 1.8rem",
//             borderRadius: "40px",
//             textDecoration: "none",
//             fontWeight: 600,
//             display: "inline-block",
//             transition: "all 0.2s",
//             cursor: "pointer",
//             border: "none",
//         },
//         btnOutline: {
//             border: "2px solid #a20000",
//             color: "#a20000",
//             padding: "0.8rem 1.8rem",
//             borderRadius: "40px",
//             textDecoration: "none",
//             fontWeight: 600,
//             display: "inline-block",
//             backgroundColor: "transparent",
//             transition: "all 0.2s",
//             cursor: "pointer",
//         },
//         heroStats: {
//             width: "100%",
//             display: "grid",
//             gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
//             gap: "1rem",
//         },
//         statItem: {
//             textAlign: "center",
//             backgroundColor: "#fff",
//             padding: "1.2rem 0.8rem",
//             borderRadius: "20px",
//             boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
//             transition: "transform 0.2s",
//         },
//         statNum: { fontSize: "2.2rem", fontWeight: 700, color: "#111", lineHeight: 1 },
//         statNumSpan: { fontSize: "1rem", fontWeight: 400, color: "#666" },
//         statLabel: { fontSize: "0.85rem", color: "#555", marginTop: "0.5rem" },

//         // RIGHT column of hero: the form card
//         heroRight: {
//             flex: "1 1 420px",
//             maxWidth: "560px",
//             position: "relative",
//             zIndex: 2,
//         },
//         formCard: {
//             backgroundColor: "#fff",
//             borderRadius: "28px",
//             padding: "2rem",
//             boxShadow: "0 12px 40px rgba(0,0,0,0.12)",
//             border: "1px solid rgba(162,0,0,0.08)",
//         },
//         formHeader: {
//             textAlign: "center",
//             marginBottom: "1.5rem",
//         },
//         formTitle: {
//             fontSize: "clamp(1.4rem, 3vw, 1.75rem)",
//             fontFamily: "'DM Serif Display', serif",
//             marginBottom: "0.4rem",
//             lineHeight: 1.2,
//         },
//         formSub: {
//             fontSize: "0.9rem",
//             color: "#555",
//             margin: 0,
//         },
//         formRow: {
//             display: "flex",
//             flexWrap: "wrap",
//             gap: "1rem",
//             marginBottom: "1rem",
//         },
//         formGroup: {
//             flex: "1 1 180px",
//             display: "flex",
//             flexDirection: "column",
//             gap: "0.4rem",
//         },
//         label: {
//             fontWeight: 600,
//             fontSize: "0.8rem",
//             color: "#333",
//         },
//         input: {
//             padding: "0.7rem 0.9rem",
//             border: "1px solid #ddd",
//             borderRadius: "14px",
//             fontSize: "0.95rem",
//             fontFamily: "'Inter', sans-serif",
//             transition: "border 0.2s",
//             outline: "none",
//             backgroundColor: "#fff",
//         },
//         select: {
//             padding: "0.7rem 0.9rem",
//             border: "1px solid #ddd",
//             borderRadius: "14px",
//             fontSize: "0.95rem",
//             fontFamily: "'Inter', sans-serif",
//             outline: "none",
//             backgroundColor: "#fff",
//             cursor: "pointer",
//         },
//         textarea: {
//             padding: "0.7rem 0.9rem",
//             border: "1px solid #ddd",
//             borderRadius: "14px",
//             fontSize: "0.95rem",
//             fontFamily: "'Inter', sans-serif",
//             resize: "vertical",
//             minHeight: "80px",
//             outline: "none",
//         },
//         submitBtn: {
//             backgroundColor: "#a20000",
//             color: "white",
//             padding: "0.8rem 2rem",
//             border: "none",
//             borderRadius: "40px",
//             fontWeight: 600,
//             fontSize: "1rem",
//             cursor: "pointer",
//             transition: "all 0.2s",
//             width: "100%",
//             marginTop: "0.5rem",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             gap: "0.5rem",
//         },

//         // Pillars
//         pillars: {
//             display: "flex",
//             flexWrap: "wrap",
//             justifyContent: "space-between",
//             gap: "2rem",
//             padding: "3rem 5%",
//             backgroundColor: "#fff",
//             borderBottom: "1px solid #eee",
//         },
//         pillar: {
//             flex: "1 1 250px",
//             display: "flex",
//             gap: "1rem",
//             alignItems: "flex-start",
//         },
//         pillarIcon: {
//             width: "44px",
//             height: "44px",
//             backgroundColor: "#f0f0f0",
//             borderRadius: "12px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             flexShrink: 0,
//         },
//         pillarIconSvg: { width: "24px", height: "24px", stroke: "#a20000", fill: "none", strokeWidth: "1.5" },
//         pillarTitle: { fontWeight: 700, fontSize: "1.1rem", marginBottom: "0.3rem" },
//         pillarDesc: { fontSize: "0.9rem", color: "#555", lineHeight: 1.4 },
//         section: { padding: "4rem 5%", maxWidth: "1400px", margin: "0 auto" },
//         sectionEyebrow: {
//             display: "inline-block",
//             color: "#a20000",
//             fontWeight: 600,
//             fontSize: "0.8rem",
//             textTransform: "uppercase",
//             letterSpacing: "1px",
//             marginBottom: "1rem",
//         },
//         sectionTitle: {
//             fontSize: "clamp(1.8rem, 4vw, 2.5rem)",
//             fontFamily: "'DM Serif Display', serif",
//             marginBottom: "1rem",
//             lineHeight: 1.2,
//         },
//         sectionLead: { fontSize: "1.1rem", color: "#444", maxWidth: "800px", marginBottom: "3rem" },
//         complianceDual: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(340px,1fr))", gap: "2.5rem" },
//         complianceCard: {
//             backgroundColor: "#faf9f8",
//             borderRadius: "28px",
//             padding: "2rem",
//             transition: "transform 0.2s",
//             height: "100%",
//         },
//         nziaCriteria: { display: "flex", flexDirection: "column", gap: "1rem", marginTop: "1.2rem" },
//         criteriaItem: { display: "flex", alignItems: "center", gap: "0.8rem" },
//         criteriaCheck: {
//             width: "22px",
//             height: "22px",
//             backgroundColor: "#a20000",
//             borderRadius: "50%",
//             display: "inline-flex",
//             alignItems: "center",
//             justifyContent: "center",
//             flexShrink: 0,
//         },
//         criteriaCheckSvg: { width: "12px", height: "12px", stroke: "white", strokeWidth: "2", fill: "none" },
//         ferxStatsRow: { display: "flex", gap: "1rem", marginTop: "1.5rem", flexWrap: "wrap", justifyContent: "space-between" },
//         ferxStat: { textAlign: "center", flex: 1 },
//         ferxStatNum: { fontSize: "1.8rem", fontWeight: 700, color: "#a20000" },
//         ferxComplianceGrid: { display: "grid", gap: "1rem", marginTop: "1rem" },
//         ferxComplianceItem: { borderLeft: "3px solid #a20000", paddingLeft: "1rem" },
//         productsGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px,1fr))", gap: "2rem" },
//         productCard: {
//             border: "1px solid #e0e0e0",
//             borderRadius: "24px",
//             padding: "1.5rem",
//             backgroundColor: "#fff",
//             transition: "all 0.25s",
//             boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
//         },
//         productBadge: { display: "inline-block", backgroundColor: "#a20000", color: "white", fontSize: "0.7rem", padding: "0.2rem 0.6rem", borderRadius: "20px", marginBottom: "1rem" },
//         productName: { fontSize: "1.6rem", fontWeight: 700, fontFamily: "'DM Serif Display', serif" },
//         productSub: { color: "#666", marginBottom: "1rem", fontSize: "0.9rem" },
//         productSpec: { display: "flex", justifyContent: "space-between", borderTop: "1px solid #eee", padding: "0.7rem 0", fontSize: "0.85rem" },
//         specKey: { color: "#555" },
//         specVal: { fontWeight: 500, color: "#111" },
//         highlight: { color: "#a20000", fontWeight: 700 },
//         productFooter: { display: "flex", flexWrap: "wrap", gap: "0.5rem", marginTop: "1rem" },
//         productTag: { fontSize: "0.7rem", backgroundColor: "#f0f0f0", padding: "0.2rem 0.6rem", borderRadius: "20px", color: "#333" },
//         greenTag: { backgroundColor: "#e6f4ea", color: "#2e7d32" },
//         twoColumnLayout: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(360px,1fr))", gap: "2.5rem", marginTop: "1rem" },
//         bomChain: { display: "flex", flexDirection: "column", gap: "1.2rem" },
//         bomItem: { display: "flex", gap: "1rem", alignItems: "flex-start" },
//         bomDot: { width: "28px", height: "28px", backgroundColor: "#a20000", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
//         bomDotSvg: { width: "14px", height: "14px", stroke: "white", strokeWidth: "2", fill: "none" },
//         complianceFlags: { display: "grid", gap: "1rem" },
//         flagCard: { backgroundColor: "#f5f5f5", borderRadius: "16px", padding: "1.2rem", transition: "transform 0.2s" },
//         flagTags: { display: "flex", flexWrap: "wrap", gap: "0.5rem", marginTop: "0.8rem" },
//         flagTag: { backgroundColor: "#fff", padding: "0.2rem 0.8rem", borderRadius: "30px", fontSize: "0.75rem", border: "1px solid #ddd" },
//         certsGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(190px,1fr))", gap: "1.2rem", marginTop: "1rem" },
//         certCard: { backgroundColor: "#fff", border: "1px solid #eee", borderRadius: "20px", padding: "1.2rem", textAlign: "center", transition: "all 0.25s", boxShadow: "0 2px 8px rgba(0,0,0,0.04)" },
//         certIcon: { width: "40px", height: "40px", margin: "0 auto 0.8rem", fill: "none", stroke: "#a20000", strokeWidth: "1.5" },
//         certName: { fontWeight: 700, marginBottom: "0.3rem", fontSize: "0.9rem" },
//         certDetail: { fontSize: "0.75rem", color: "#666" },
//         esgTabsContainer: { marginTop: "2rem" },
//         esgTabs: { display: "flex", gap: "1rem", borderBottom: "2px solid #eee", marginBottom: "2rem", flexWrap: "wrap" },
//         esgTab: { padding: "0.8rem 1.5rem", cursor: "pointer", fontWeight: 600, color: "#666", transition: "all 0.2s", borderBottom: "2px solid transparent" },
//         activeEsgTab: { color: "#a20000", borderBottomColor: "#a20000" },
//         esgPanel: { display: "none" },
//         activeEsgPanel: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: "1.5rem" },
//         esgItem: { backgroundColor: "#faf9f8", borderRadius: "20px", padding: "1.5rem", transition: "transform 0.2s", height: "100%" },
//         esgItemNum: { fontSize: "2rem", fontWeight: 700, color: "#a20000", opacity: 0.4, marginBottom: "0.5rem" },
//         factories: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px,1fr))", gap: "1.5rem", marginTop: "2rem" },
//         factoryCard: { backgroundColor: "#a20000", color: "white", padding: "1.5rem", borderRadius: "24px", transition: "transform 0.2s" },
//         factoryNum: { fontSize: "0.8rem", color: "#ffffff", marginBottom: "0.5rem" },
//         factoryName: { fontSize: "1.6rem", fontWeight: 700, fontFamily: "'DM Serif Display', serif", marginBottom: "0.25rem" },
//         factoryLoc: { fontSize: "0.8rem", color: "#ffffff", marginBottom: "1rem" },
//         factoryCap: { fontWeight: 700, fontSize: "1.1rem" },
//         ctaSection: { backgroundColor: "#a20000", color: "white", padding: "3rem 5%", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", gap: "1.5rem" },
//         btnWhite: { backgroundColor: "white", color: "#a20000", padding: "0.8rem 1.8rem", borderRadius: "40px", textDecoration: "none", fontWeight: 600, marginRight: "1rem", transition: "all 0.2s", display: "inline-block" },
//         btnGhost: { border: "2px solid white", color: "white", padding: "0.8rem 1.8rem", borderRadius: "40px", textDecoration: "none", fontWeight: 600, backgroundColor: "transparent", transition: "all 0.2s", display: "inline-block" },
//         footer: { display: "flex", flexWrap: "wrap", justifyContent: "space-between", padding: "3rem 5%", backgroundColor: "#faf9f8", gap: "2rem" },
//         footerBrand: { flex: "1 1 250px" },
//         footerLinks: { display: "flex", flexWrap: "wrap", gap: "2rem", flex: "2 1 400px", justifyContent: "space-between" },
//         footerCol: { display: "flex", flexDirection: "column", gap: "0.5rem" },
//         footerColH4: { fontSize: "1rem", fontWeight: 700, marginBottom: "0.5rem" },
//         footerLink: { textDecoration: "none", color: "#555", fontSize: "0.85rem", transition: "color 0.2s" },
//         footerBottom: { textAlign: "center", padding: "1.5rem", borderTop: "1px solid #eee", fontSize: "0.8rem", color: "#777", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "1rem" },
//         divider: { height: "1px", backgroundColor: "#eee", margin: "0 5%" },
//         backToTop: {
//             position: "fixed", bottom: "2rem", right: "2rem", backgroundColor: "#a20000", color: "white", width: "44px", height: "44px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", border: "none", boxShadow: "0 2px 12px rgba(0,0,0,0.15)", transition: "all 0.2s", zIndex: 99,
//         },
//     };

//     const [formData, setFormData] = useState({
//         name: "",
//         email: "",
//         phone: "",
//         companyName: "",
//         companyDesignation: "",
//         message: "",
//     });
//     const [loading, setLoading] = useState(false);

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prev) => ({ ...prev, [name]: value }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         try {
//             setLoading(true);
//             let utm = localStorage.getItem('utm_data') || null;

//             if (!formData.name || !formData.email || !formData.phone) {
//                 alert("Please fill in all required fields (Name, Email, Phone).");
//                 return;
//             }

//             formData.utm = utm

//             await axios.post('https://gautamsolar.us/interSolar-contact', formData);

//             alert("Thank you! Your enquiry has been received. We'll get back to you soon.");
//             setFormData({ name: "", email: "", phone: "", message: "", companyName: '', companyDesignation: '' });

//         } catch (er) {
//             console.log(er)
//         }
//         finally {
//             setLoading(false)
//         }
//     };

//     return (
//         <>
//             <Helmet>
//                 <title>
//                     ESG & Compliance | Responsible Solar Manufacturing | Gautam Solar
//                 </title>

//                 <meta
//                     name="description"
//                     content="Explore Gautam Solar's ESG and compliance initiatives, including NZIA and FER-X compliant solar modules, traceable supply chains, responsible sourcing, emissions reduction and certified manufacturing."
//                 />

//                 <link
//                     rel="canonical"
//                     href="https://gautamsolar.com/esg/"
//                 />

//                 <meta
//                     name="robots"
//                     content="index, follow"
//                 />

//                 <meta
//                     property="og:title"
//                     content="ESG & Compliance | Responsible Solar Manufacturing | Gautam Solar"
//                 />

//                 <meta
//                     property="og:description"
//                     content="Explore Gautam Solar's ESG and compliance initiatives, including NZIA and FER-X compliant solar modules, traceable supply chains, responsible sourcing, emissions reduction and certified manufacturing."
//                 />

//                 <meta
//                     property="og:url"
//                     content="https://gautamsolar.com/esg/"
//                 />

//                 <meta
//                     property="og:type"
//                     content="website"
//                 />

//                 <meta
//                     property="og:site_name"
//                     content="Gautam Solar"
//                 />

//                 <script type="application/ld+json">
//                     {JSON.stringify({
//                         "@context": "https://schema.org",
//                         "@type": "Organization",
//                         "@id": "https://gautamsolar.com/#organization",
//                         "name": "Gautam Solar",
//                         "url": "https://gautamsolar.com/esg/",
//                         "telephone": "+91 93117 97248",
//                         "email": "info@gautamsolar.com",
//                         "address": {
//                             "@type": "PostalAddress",
//                             "streetAddress": "D-120-121, Okhla Industrial Area, Phase-1",
//                             "addressLocality": "New Delhi",
//                             "addressCountry": "IN"
//                         },
//                         "sameAs": [
//                             "https://www.linkedin.com/company/gautam-solar",
//                             "https://www.facebook.com/GautamSolar",
//                             "https://twitter.com/GautamSolar",
//                             "https://www.instagram.com/gautamsolar"
//                         ]
//                     })}
//                 </script>

//                 <script type="application/ld+json">
//                     {JSON.stringify({
//                         "@context": "https://schema.org",
//                         "@type": "WebSite",
//                         "@id": "https://gautamsolar.com/#website",
//                         "url": "https://gautamsolar.com/esg/",
//                         "name": "Gautam Solar",
//                         "publisher": {
//                             "@id": "https://gautamsolar.com/#organization"
//                         }
//                     })}
//                 </script>

//                 <script type="application/ld+json">
//                     {JSON.stringify({
//                         "@context": "https://schema.org",
//                         "@type": "WebPage",
//                         "@id": "https://gautamsolar.com/esg/#webpage",
//                         "url": "https://gautamsolar.com/esg/",
//                         "name": "ESG & Compliance | Responsible Solar Manufacturing | Gautam Solar",
//                         "description": "Gautam Solar's ESG and compliance initiatives covering NZIA and FER-X compliance, supply chain traceability, responsible sourcing, emissions reduction, certified operations and ESG commitments.",
//                         "inLanguage": "en",
//                         "isPartOf": {
//                             "@id": "https://gautamsolar.com/#website"
//                         },
//                         "publisher": {
//                             "@id": "https://gautamsolar.com/#organization"
//                         },
//                         "about": [
//                             { "@type": "Thing", "name": "ESG and Compliance" },
//                             { "@type": "Thing", "name": "Responsible Solar Manufacturing" },
//                             { "@type": "Thing", "name": "Solar Supply Chain Traceability" },
//                             { "@type": "Thing", "name": "NZIA Compliance" },
//                             { "@type": "Thing", "name": "FER-X Compliance" }
//                         ],
//                         "breadcrumb": {
//                             "@id": "https://gautamsolar.com/esg/#breadcrumb"
//                         }
//                     })}
//                 </script>

//                 <script type="application/ld+json">
//                     {JSON.stringify({
//                         "@context": "https://schema.org",
//                         "@type": "ItemList",
//                         "@id": "https://gautamsolar.com/esg/#module-range",
//                         "name": "NZIA Compliant Gautam Solar Module Range",
//                         "description": "Gautam Solar's N-Type TOPCon module range displayed on its ESG and Compliance page.",
//                         "numberOfItems": 3,
//                         "itemListElement": [
//                             {
//                                 "@type": "ListItem",
//                                 "position": 1,
//                                 "item": {
//                                     "@type": "Product",
//                                     "name": "G12 R TOPCon",
//                                     "brand": { "@type": "Brand", "name": "Gautam Solar" },
//                                     "category": "N-Type TOPCon Solar Module",
//                                     "description": "N-Type rectangular-cell TOPCon solar module with 620–640 Wp power, efficiency up to 23.69%, UL and IEC standards, and traceable non-Chinese cells.",
//                                     "additionalProperty": [
//                                         { "@type": "PropertyValue", "name": "Technology", "value": "N-Type TOPCon" },
//                                         { "@type": "PropertyValue", "name": "Power", "value": "620–640 Wp" },
//                                         { "@type": "PropertyValue", "name": "Efficiency", "value": "Up to 23.69%" },
//                                         { "@type": "PropertyValue", "name": "Cell Size", "value": "105×182 mm" },
//                                         { "@type": "PropertyValue", "name": "Temperature Coefficient", "value": "-0.29%/°C" },
//                                         { "@type": "PropertyValue", "name": "Certification", "value": "UL & IEC Standards" },
//                                         { "@type": "PropertyValue", "name": "Warranty", "value": "12 year / 30 year" }
//                                     ]
//                                 }
//                             },
//                             {
//                                 "@type": "ListItem",
//                                 "position": 2,
//                                 "item": {
//                                     "@type": "Product",
//                                     "name": "G12 TOPCon",
//                                     "brand": { "@type": "Brand", "name": "Gautam Solar" },
//                                     "category": "N-Type TOPCon Solar Module",
//                                     "description": "N-Type standard-cell TOPCon solar module with 690–720 Wp power, efficiency up to 23.20%, IEC CB standards and traceable non-Chinese cells.",
//                                     "additionalProperty": [
//                                         { "@type": "PropertyValue", "name": "Technology", "value": "N-Type TOPCon" },
//                                         { "@type": "PropertyValue", "name": "Power", "value": "690–720 Wp" },
//                                         { "@type": "PropertyValue", "name": "Efficiency", "value": "Up to 23.20%" },
//                                         { "@type": "PropertyValue", "name": "Cell Size", "value": "105×210 mm" },
//                                         { "@type": "PropertyValue", "name": "Temperature Coefficient", "value": "-0.30%/°C" },
//                                         { "@type": "PropertyValue", "name": "Certification", "value": "IEC CB Standards" },
//                                         { "@type": "PropertyValue", "name": "Warranty", "value": "12 year / 30 year" }
//                                     ]
//                                 }
//                             },
//                             {
//                                 "@type": "ListItem",
//                                 "position": 3,
//                                 "item": {
//                                     "@type": "Product",
//                                     "name": "M10 R TOPCon",
//                                     "brand": { "@type": "Brand", "name": "Gautam Solar" },
//                                     "category": "N-Type TOPCon Solar Module",
//                                     "description": "N-Type large-scale TOPCon solar module with 590–600 Wp power, efficiency up to 23.23%, UL and IEC standards and traceable non-Chinese cells.",
//                                     "additionalProperty": [
//                                         { "@type": "PropertyValue", "name": "Technology", "value": "N-Type TOPCon" },
//                                         { "@type": "PropertyValue", "name": "Power", "value": "590–600 Wp" },
//                                         { "@type": "PropertyValue", "name": "Efficiency", "value": "Up to 23.23%" },
//                                         { "@type": "PropertyValue", "name": "Cell Size", "value": "91.8×182 mm" },
//                                         { "@type": "PropertyValue", "name": "Temperature Coefficient", "value": "-0.30%/°C" },
//                                         { "@type": "PropertyValue", "name": "Certification", "value": "UL & IEC Standards" },
//                                         { "@type": "PropertyValue", "name": "Warranty", "value": "12 year / 30 year" }
//                                     ]
//                                 }
//                             }
//                         ]
//                     })}
//                 </script>

//                 <script type="application/ld+json">
//                     {JSON.stringify({
//                         "@context": "https://schema.org",
//                         "@type": "BreadcrumbList",
//                         "@id": "https://gautamsolar.com/esg/#breadcrumb",
//                         "itemListElement": [
//                             {
//                                 "@type": "ListItem",
//                                 "position": 1,
//                                 "name": "Home",
//                                 "item": "https://gautamsolar.com/"
//                             },
//                             {
//                                 "@type": "ListItem",
//                                 "position": 2,
//                                 "name": "ESG & Compliance",
//                                 "item": "https://gautamsolar.com/esg/"
//                             }
//                         ]
//                     })}
//                 </script>
//             </Helmet>
//             <div style={styles.container}>
//                 <style>{`
//         .esg-comp-wrapper a, .esg-comp-wrapper button { cursor: pointer; }
//         .esg-comp-wrapper .nav-link:hover { color: #a20000 !important; }
//         .esg-comp-wrapper .nav-cta:hover, .esg-comp-wrapper .btn-primary:hover { background-color: #a20000 !important; transform: translateY(-2px); }
//         .esg-comp-wrapper .btn-outline:hover { background-color: #a20000 !important; color: white !important; transform: translateY(-2px); }
//         .esg-comp-wrapper .stat-item:hover, .esg-comp-wrapper .product-card:hover, .esg-comp-wrapper .cert-card:hover { transform: translateY(-4px); box-shadow: 0 12px 24px rgba(0,0,0,0.1); }
//         .esg-comp-wrapper .compliance-card:hover, .esg-comp-wrapper .flag-card:hover, .esg-comp-wrapper .esg-item:hover { transform: translateY(-3px); }
//         .esg-comp-wrapper .factory-card:hover { transform: translateY(-6px); background-color: #1a1a1a !important; }
//         .esg-comp-wrapper .btn-white:hover { background-color: #f0f0f0 !important; transform: translateY(-2px); }
//         .esg-comp-wrapper .btn-ghost:hover { background-color: white !important; color: #a20000 !important; }
//         .esg-comp-wrapper .footer-link:hover { color: #a20000 !important; }
//         .esg-comp-wrapper .back-to-top:hover { transform: scale(1.05); background-color: #a20000; }
//         .esg-comp-wrapper .esg-item-row:hover { transform: translateY(-3px); }
//         .esg-comp-wrapper .submit-btn:hover:not(:disabled) { background-color: #8a0000 !important; transform: translateY(-2px); }
//         @media (max-width: 768px) {
//           .esg-comp-wrapper nav { flex-direction: column; gap: 1rem; }
//         }
//       `}</style>

//                 {/* ============ HERO with embedded form on the right ============ */}
//                 <div style={styles.hero}>
//                     <video
//                         autoPlay
//                         loop
//                         muted
//                         playsInline
//                         style={{
//                             position: "absolute",
//                             top: 0,
//                             left: 0,
//                             width: "100%",
//                             height: "100%",
//                             objectFit: "cover",
//                             zIndex: 0,
//                             opacity: 0.3,
//                         }}
//                     >
//                         <source src="/2025_Factory_Video1.mp4" type="video/mp4" />
//                         Your browser does not support the video tag.
//                     </video>

//                     <div
//                         style={{
//                             position: "absolute",
//                             top: 0,
//                             left: 0,
//                             width: "100%",
//                             height: "100%",
//                             backgroundColor: "rgba(0, 0, 0, 0.28)",
//                             zIndex: 1,
//                         }}
//                     />

//                     {/* LEFT: content + stats */}
//                     <div style={styles.heroLeft}>
//                         <div style={styles.heroContent}>
//                             <div style={styles.heroEyebrow}>
//                                 <span style={styles.heroEyebrowDot}></span> ESG & COMPLIANCE
//                             </div>
//                             <h1 style={styles.heroH1}>
//                                 Built for a<br />
//                                 <span style={styles.heroEm}>Responsible</span>
//                                 <br />Energy Future
//                             </h1>
//                             <p style={styles.heroDesc}>
//                                 Gautam Solar's NZIA and FER-X compliant modules deliver traceable, ESG-aligned, non-Chinese cell technology — purpose-built for Europe's new procurement era and global responsible sourcing mandates.
//                             </p>
//                         </div>

//                         <div style={styles.heroStats}>
//                             <div className="stat-item" style={styles.statItem}>
//                                 <div style={styles.statNum}>5<span style={styles.statNumSpan}>GW</span></div>
//                                 <div style={styles.statLabel}>Solar Module Mfg. in India</div>
//                             </div>
//                             <div className="stat-item" style={styles.statItem}>
//                                 <div style={styles.statNum}>3<span style={styles.statNumSpan}>GW</span></div>
//                                 <div style={styles.statLabel}>Cell Manufacturing in India</div>
//                             </div>
//                             <div className="stat-item" style={styles.statItem}>
//                                 <div style={styles.statNum}>29<span style={styles.statNumSpan}>+</span></div>
//                                 <div style={styles.statLabel}>Years of Solar Experience</div>
//                             </div>
//                             <div className="stat-item" style={styles.statItem}>
//                                 <div style={styles.statNum}>A<span style={styles.statNumSpan}>*</span></div>
//                                 <div style={styles.statLabel}>Wood Mackenzie Grade A — H1 2025</div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* RIGHT: request form card */}
//                     <div style={styles.heroRight}>
//                         <div style={styles.formCard}>
//                             <div style={styles.formHeader}>
//                                 <span style={{ ...styles.sectionEyebrow, marginBottom: "0.5rem" }}>
//                                     Request Information
//                                 </span>
//                                 <h2 style={styles.formTitle}>
//                                     Let's Discuss Your <span style={styles.heroEm}>Project Needs</span>
//                                 </h2>
//                                 <p style={styles.formSub}>
//                                     Fill out the form and our ESG compliance team will get back to you.
//                                 </p>
//                             </div>

//                             <form onSubmit={handleSubmit}>
//                                 {/* Row 1: Name + Email */}
//                                 <div style={styles.formRow}>
//                                     <div style={styles.formGroup}>
//                                         <label style={styles.label}>
//                                             Full Name <span style={{ color: "#a20000" }}>*</span>
//                                         </label>
//                                         <input
//                                             type="text"
//                                             name="name"
//                                             value={formData.name}
//                                             onChange={handleInputChange}
//                                             style={styles.input}
//                                             placeholder="Name"
//                                             required
//                                         />
//                                     </div>
//                                     <div style={styles.formGroup}>
//                                         <label style={styles.label}>
//                                             Email <span style={{ color: "#a20000" }}>*</span>
//                                         </label>
//                                         <input
//                                             type="email"
//                                             name="email"
//                                             value={formData.email}
//                                             onChange={handleInputChange}
//                                             style={styles.input}
//                                             placeholder="Email"
//                                             required
//                                         />
//                                     </div>
//                                 </div>

//                                 {/* Row 2: Phone + Company */}
//                                 <div style={styles.formRow}>
//                                     <div style={styles.formGroup}>
//                                         <label style={styles.label}>
//                                             Phone <span style={{ color: "#a20000" }}>*</span>
//                                         </label>
//                                         <input
//                                             type="tel"
//                                             name="phone"
//                                             value={formData.phone}
//                                             onChange={handleInputChange}
//                                             style={styles.input}
//                                             placeholder="Phone Number"
//                                             required
//                                         />
//                                     </div>
//                                     <div style={styles.formGroup}>
//                                         <label style={styles.label}>
//                                             Company
//                                         </label>
//                                         <input
//                                             type="text"
//                                             name="companyName"
//                                             value={formData.companyName}
//                                             onChange={handleInputChange}
//                                             style={styles.input}
//                                             placeholder="Company Name"
//                                             required
//                                         />
//                                     </div>
//                                 </div>

//                                 {/* Row 3: Designation */}
//                                 <div style={styles.formRow}>
//                                     <div style={{ ...styles.formGroup, flex: "1 1 100%" }}>
//                                         <label style={styles.label}>
//                                             Company Designation
//                                         </label>
//                                         <select
//                                             name="companyDesignation"
//                                             value={formData.companyDesignation}
//                                             onChange={handleInputChange}
//                                             style={styles.select}
//                                             required
//                                         >
//                                             <option value="">Select designation</option>
//                                             <option value="EPC">EPC</option>
//                                             <option value="Dealer">Dealer</option>
//                                             <option value="Distributor">Distributor</option>
//                                             <option value="Other">Other</option>
//                                         </select>
//                                     </div>
//                                 </div>

//                                 {/* Row 4: Message */}
//                                 <div style={{ ...styles.formGroup, marginBottom: "1rem" }}>
//                                     <label style={styles.label}>
//                                         Short Message
//                                     </label>
//                                     <textarea
//                                         name="message"
//                                         value={formData.message}
//                                         onChange={handleInputChange}
//                                         style={styles.textarea}
//                                         placeholder="Tell us about your project, required modules, or compliance documentation needs..."
//                                     />
//                                 </div>

//                                 <button
//                                     type="submit"
//                                     disabled={loading}
//                                     className="submit-btn"
//                                     style={{
//                                         ...styles.submitBtn,
//                                         cursor: loading ? "not-allowed" : "pointer",
//                                         opacity: loading ? 0.7 : 1,
//                                     }}
//                                 >
//                                     {loading ? (
//                                         <RiLoader5Line size={28} style={{ animation: "spin 1s linear infinite" }} />
//                                     ) : (
//                                         'Send Enquiry →'
//                                     )}
//                                 </button>

//                                 <style>{`
//                                     @keyframes spin {
//                                         0% { transform: rotate(0deg); }
//                                         100% { transform: rotate(360deg); }
//                                     }
//                                 `}</style>
//                             </form>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Pillars */}
//                 <div style={styles.pillars}>
//                     <div style={styles.pillar}><div style={styles.pillarIcon}><svg viewBox="0 0 24 24" style={styles.pillarIconSvg}><path d="M9 12l2 2 4-4M12 3C7 3 3 7 3 12s4 9 9 9 9-4 9-9-4-9-9-9z" strokeLinecap="round" strokeLinejoin="round" /></svg></div><div><div style={styles.pillarTitle}>Non-Forced Labour Compliant</div><div style={styles.pillarDesc}>100% traceable Bill of Materials with no forced labour in the supply chain. UFLPA and FEOC compliant.</div></div></div>
//                     <div style={styles.pillar}><div style={styles.pillarIcon}><svg viewBox="0 0 24 24" style={styles.pillarIconSvg}><path d="M3 3h18v18H3zM3 9h18M9 21V9" strokeLinecap="round" strokeLinejoin="round" /></svg></div><div><div style={styles.pillarTitle}>Non-Chinese Cells with Traceability</div><div style={styles.pillarDesc}>N-Type TOPCon cells manufactured in India with verified origin at every component level.</div></div></div>
//                     <div style={styles.pillar}><div style={styles.pillarIcon}><svg viewBox="0 0 24 24" style={styles.pillarIconSvg}><path d="M12 3v4m0 10v4M3 12h4m10 0h4M6.34 6.34l2.83 2.83m5.66 5.66l2.83 2.83M6.34 17.66l2.83-2.83m5.66-5.66l2.83-2.83" strokeLinecap="round" strokeLinejoin="round" /></svg></div><div><div style={styles.pillarTitle}>ESG Aligned Factory & Supply Chain</div><div style={styles.pillarDesc}>Reduced Scope 1, 2 & 3 emissions. ISO 9001, 14001 & 45001 certified operations across all plants.</div></div></div>
//                 </div>

//                 {/* NZIA + FER-X combined */}
//                 <section id="nzia-ferx" style={styles.section}>
//                     <span style={styles.sectionEyebrow}>EU Regulation & Italy's FER-X</span>
//                     <h2 style={styles.sectionTitle}>NZIA & FER‑X <span style={styles.heroEm}>Compliance Hub</span></h2>
//                     <p style={styles.sectionLead}>One integrated standard for European resilience — Gautam Solar meets both NZIA non‑price criteria and Italy's FER‑X requirements for non‑Chinese components.</p>
//                     <div style={styles.complianceDual}>
//                         <div className="compliance-card" style={styles.complianceCard}>
//                             <h3>Net Zero Industry Act (NZIA)</h3>
//                             <p>Adopted May 2024. EU member states apply non-price criteria – resilience, sustainability, responsible business conduct. Tolerance for price differences up to 20%.</p>
//                             <div style={styles.nziaCriteria}>
//                                 {["Resilience Contribution — non-Chinese supply chain", "Sustainability — reduced Scope 1,2,3, ISO 14001", "Responsible Business Conduct — labour compliance", "Supply Chain Traceability — 100% BOM traceable", "ESG Disclosure & audit documentation", "Recyclable materials & end-of-life programs"].map(text => (
//                                     <div key={text} style={styles.criteriaItem}><div style={styles.criteriaCheck}><svg viewBox="0 0 12 12" style={styles.criteriaCheckSvg}><polyline points="2,6 5,9 10,3" /></svg></div><span>{text}</span></div>
//                                 ))}
//                             </div>
//                         </div>
//                         <div className="compliance-card" style={styles.complianceCard}>
//                             <h3>🇮🇹 FER‑X (Italy NZIA implementation)</h3>
//                             <p>For projects &gt;1 MW: mandatory non-Chinese modules. First auction awarded 1.1 GW at €66.38/MWh. Gautam Solar qualifies with 4+ non-Chinese components.</p>
//                             <div style={styles.ferxStatsRow}>
//                                 <div style={styles.ferxStat}><div style={styles.ferxStatNum}>1.1 GW</div><div>awarded</div></div>
//                                 <div style={styles.ferxStat}><div style={styles.ferxStatNum}>88</div><div>projects</div></div>
//                                 <div style={styles.ferxStat}><div style={styles.ferxStatNum}>4+</div><div>non‑Chinese components</div></div>
//                             </div>
//                             <div style={styles.ferxComplianceGrid}>
//                                 <div style={styles.ferxComplianceItem}><h5>Solar Cells</h5><p>N-Type TOPCon cells made in India (3GW Malanpur).</p></div>
//                                 <div style={styles.ferxComplianceItem}><h5>Module Assembly</h5><p>5GW capacity Haridwar & Bhiwani, IEC/UL certified.</p></div>
//                                 <div style={styles.ferxComplianceItem}><h5>Full BOM documentation</h5><p>Cell, glass, frame, encapsulant – traceable & available for GSE.</p></div>
//                             </div>
//                         </div>
//                     </div>
//                 </section>
//                 <div style={styles.divider}></div>

//                 {/* Products */}
//                 <section id="products" style={styles.section}>
//                     <span style={{ ...styles.sectionEyebrow, color: "#a20000" }}>NZIA & FER-X Compliant Modules</span>
//                     <h2 style={styles.sectionTitle}>Our Compliant <span style={{ color: "#a20000" }}>Module Range</span></h2>
//                     <p style={styles.sectionLead}>Three high-performance N-Type TOPCon series, all NZIA-compliant, IEC/UL certified, and fully traceable.</p>
//                     <div style={styles.productsGrid}>
//                         {[["G12 R TOPCon", "N-Type · Rectangular Cell · 620–640 Wp", "Up to 23.69%", "620 – 640 Wp", "N-Type TOPCon 105×182mm", "−0.29%/°C", "UL & IEC Standards", "12 yr / 30 yr", "FER-X Eligible"],
//                         ["G12 TOPCon", "N-Type · Standard Cell · 690–720 Wp", "Up to 23.20%", "690 – 720 Wp", "N-Type TOPCon 105×210mm", "−0.30%/°C", "IEC CB Standards", "12 yr / 30 yr", "High-Power"],
//                         ["M10 R TOPCon", "N-Type · Large-Scale · 590–600 Wp", "Up to 23.23%", "590 – 600 Wp", "N-Type TOPCon 91.8×182mm", "−0.30%/°C", "UL & IEC Standards", "12 yr / 30 yr", "Utility-Scale"]].map((prod, i) => (
//                             <div key={i} className="product-card" style={styles.productCard}>
//                                 <div style={styles.productBadge}>NZIA Compliant</div>
//                                 <div style={styles.productName}>{prod[0]}</div><div style={styles.productSub}>{prod[1]}</div>
//                                 <div style={styles.productSpec}><span style={styles.specKey}>Efficiency</span><span style={{ ...styles.specVal, ...styles.highlight }}>{prod[2]}</span></div>
//                                 <div style={styles.productSpec}><span>Power</span><span>{prod[3]}</span></div>
//                                 <div style={styles.productSpec}><span>Cells</span><span>{prod[4]}</span></div>
//                                 <div style={styles.productSpec}><span>Temp Coeff</span><span>{prod[5]}</span></div>
//                                 <div style={styles.productSpec}><span>Certification</span><span>{prod[6]}</span></div>
//                                 <div style={styles.productSpec}><span>Warranty</span><span>{prod[7]}</span></div>
//                                 <div style={styles.productFooter}><span style={{ ...styles.productTag, ...styles.greenTag }}>Non-Chinese Cells</span><span style={styles.productTag}>Traceable BOM</span><span style={styles.productTag}>{prod[8]}</span></div>
//                             </div>
//                         ))}
//                     </div>
//                 </section>

//                 {/* Traceability + Certifications */}
//                 <section id="trace-cert" style={styles.section}>
//                     <span style={styles.sectionEyebrow}>Trust & Transparency</span>
//                     <h2 style={styles.sectionTitle}>Traceability <span style={styles.heroEm}>meets</span> Global Certification</h2>
//                     <p style={styles.sectionLead}>100% component‑level traceability + industry‑leading certifications: bankability for every project.</p>
//                     <div style={styles.twoColumnLayout}>
//                         <div>
//                             <h3 style={{ fontFamily: "'DM Serif Display', serif", marginBottom: "1.2rem" }}>Bill of Materials – fully traceable</h3>
//                             <div style={styles.bomChain}>
//                                 {[{ title: "Solar Cell", desc: "N-Type TOPCon cells made in India. Non-Chinese, non-Xinjiang." }, { title: "Glass", desc: "2.0mm AR coated, high transmission." }, { title: "EVA/POE Encapsulant", desc: "PID Free, UV resistant, batch traceable." }, { title: "Junction Box", desc: "IP68, MC4 compatible." }, { title: "Frame & Ribbon", desc: "Anodised aluminium, full material certification." }].map((item, i) => (
//                                     <div key={i} style={styles.bomItem}><div style={styles.bomDot}><svg viewBox="0 0 14 14" style={styles.bomDotSvg}>{i === 0 ? <circle cx="7" cy="7" r="4" /> : i === 1 ? <rect x="2" y="2" width="10" height="10" rx="1" /> : <path d="M2 2h10v10H2z" />}</svg></div><div><h5>{item.title}</h5><p>{item.desc}</p></div></div>
//                                 ))}
//                             </div>
//                         </div>
//                         <div>
//                             <h3 style={{ fontFamily: "'DM Serif Display', serif", marginBottom: "1.2rem" }}>Compliance & Certifications</h3>
//                             <div style={styles.complianceFlags}>
//                                 <div className="flag-card" style={styles.flagCard}><h5>🇺🇸 UFLPA & FEOC</h5><div style={styles.flagTags}><span style={styles.flagTag}>UFLPA Compliant</span><span style={styles.flagTag}>FEOC Compliant</span><span style={styles.flagTag}>Supply Chain Docs</span></div></div>
//                                 <div className="flag-card" style={styles.flagCard}><h5>🇪🇺 Europe ESG</h5><div style={styles.flagTags}><span style={styles.flagTag}>Due Diligence</span><span style={styles.flagTag}>Carbon Reporting</span><span style={styles.flagTag}>Non-Forced Labour</span></div></div>
//                             </div>
//                             <div style={styles.certsGrid}>
//                                 {[{ name: "Kiwa PVEL Top Performer", detail: "12th Edition · 2026" }, { name: "Wood Mackenzie Grade A", detail: "Global Top 30, H1 2025" }, { name: "IEC & IEC CB", detail: "Intl. Standards" }, { name: "UL Listed", detail: "cULus Safety" }, { name: "CRISIL A-/Stable", detail: "A2+ rating" }, { name: "CE Certified", detail: "European Conformity" }, { name: "ISO 9001/14001/45001", detail: "Q&E&OH Management" }, { name: "SGS Certified", detail: "3rd party inspection" }].map((cert, i) => (
//                                     <div key={i} className="cert-card" style={styles.certCard}><div style={styles.certIcon}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" /></svg></div><div style={styles.certName}>{cert.name}</div><div style={styles.certDetail}>{cert.detail}</div></div>
//                                 ))}
//                             </div>
//                         </div>
//                     </div>
//                 </section>
//                 <div style={styles.divider}></div>

//                 {/* ESG Framework */}
//                 <section id="esg" style={styles.section}>
//                     <span style={styles.sectionEyebrow}>ESG Framework</span>
//                     <h2 style={styles.sectionTitle}>
//                         Our <span style={styles.heroEm}>Environmental, Social &amp;</span>
//                         <br />Governance Commitments
//                     </h2>
//                     <p style={styles.sectionLead}>
//                         Built into operations, supply chain, and manufacturing — not just reporting.
//                     </p>

//                     <div style={styles.esgTabsContainer}>
//                         <div style={styles.esgTabs}>
//                             <div
//                                 onClick={() => setActiveESGTab("env")}
//                                 className="esg-tab"
//                                 style={{
//                                     ...styles.esgTab,
//                                     ...(activeESGTab === "env" ? styles.activeEsgTab : {}),
//                                 }}
//                             >
//                                 Environmental
//                             </div>
//                             <div
//                                 onClick={() => setActiveESGTab("soc")}
//                                 className="esg-tab"
//                                 style={{
//                                     ...styles.esgTab,
//                                     ...(activeESGTab === "soc" ? styles.activeEsgTab : {}),
//                                 }}
//                             >
//                                 Social
//                             </div>
//                             <div
//                                 onClick={() => setActiveESGTab("gov")}
//                                 className="esg-tab"
//                                 style={{
//                                     ...styles.esgTab,
//                                     ...(activeESGTab === "gov" ? styles.activeEsgTab : {}),
//                                 }}
//                             >
//                                 Governance
//                             </div>
//                         </div>

//                         {/* Environmental Panel */}
//                         <div
//                             style={
//                                 activeESGTab === "env"
//                                     ? { display: "flex", flexDirection: "column", gap: "1.25rem", marginTop: "2rem" }
//                                     : { display: "none" }
//                             }
//                         >
//                             {[
//                                 { title: "Scope 1,2,3 Emissions Reduction", desc: "Active programmes to reduce direct, indirect, and value chain emissions across all four manufacturing facilities." },
//                                 { title: "ISO 14001 Certified", desc: "Environmental Management System certified across Haridwar, Bhiwani, and Malanpur manufacturing sites." },
//                                 { title: "Recyclable Materials", desc: "Module design incorporates recyclable glass, aluminium frames, and encapsulants, with structured end-of-life take-back and recycling programs." },
//                                 { title: "ESG Reporting", desc: "Comprehensive sustainability disclosures available including environmental performance data aligned with GRI and SASB frameworks." },
//                                 { title: "Carbon Footprint Disclosure", desc: "Product-level and facility-level carbon reporting available to support developer and lender ESG reporting obligations." },
//                                 { title: "Responsible Sourcing", desc: "All raw materials procured with verified origin documentation, prioritising suppliers with environmental certification." },
//                             ].map((item, idx) => (
//                                 <div
//                                     key={idx}
//                                     style={{ display: "flex", alignItems: "flex-start", gap: "1.5rem", backgroundColor: "#faf9f8", borderRadius: "20px", padding: "1.2rem 1.5rem", transition: "transform 0.2s" }}
//                                     className="esg-item-row"
//                                 >
//                                     <div style={{ fontSize: "2.5rem", fontWeight: 700, color: "#a20000", opacity: 0.5, lineHeight: 1, minWidth: "60px" }}>
//                                         {String(idx + 1).padStart(2, "0")}
//                                     </div>
//                                     <div style={{ flex: 1 }}>
//                                         <h4 style={{ fontSize: "1.2rem", marginBottom: "0.4rem" }}>{item.title}</h4>
//                                         <p style={{ color: "#555", lineHeight: 1.4, margin: 0 }}>{item.desc}</p>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>

//                         {/* Social Panel */}
//                         <div
//                             style={
//                                 activeESGTab === "soc"
//                                     ? { display: "flex", flexDirection: "column", gap: "1.25rem", marginTop: "2rem" }
//                                     : { display: "none" }
//                             }
//                         >
//                             {[
//                                 { title: "Non-Forced Labour BOM", desc: "Complete supply chain audit confirms no forced, bonded, or child labour at any tier — UFLPA and FEOC compliant." },
//                                 { title: "ISO 45001 OHS", desc: "Worker safety management system certified across all manufacturing facilities." },
//                                 { title: "Community Development", desc: "Active CSR programmes including medical equipment donation to AIIMS, health camps, clean mobility, and education initiatives across India." },
//                                 { title: "Women Leadership", desc: "Championing gender diversity in solar manufacturing, with women leadership recognised at national industry level." },
//                                 { title: "Make in India Jobs", desc: "Manufacturing 100% in India, directly generating thousands of skilled and semi-skilled jobs in Uttarakhand, Haryana, and Madhya Pradesh." },
//                                 { title: "Supplier Labour Audits", desc: "Regular social compliance audits conducted across the supply chain to maintain standards at every tier." },
//                             ].map((item, idx) => (
//                                 <div
//                                     key={idx}
//                                     style={{ display: "flex", alignItems: "flex-start", gap: "1.5rem", backgroundColor: "#faf9f8", borderRadius: "20px", padding: "1.2rem 1.5rem", transition: "transform 0.2s" }}
//                                     className="esg-item-row"
//                                 >
//                                     <div style={{ fontSize: "2.5rem", fontWeight: 700, color: "#a20000", opacity: 0.5, lineHeight: 1, minWidth: "60px" }}>
//                                         {String(idx + 1).padStart(2, "0")}
//                                     </div>
//                                     <div style={{ flex: 1 }}>
//                                         <h4 style={{ fontSize: "1.2rem", marginBottom: "0.4rem" }}>{item.title}</h4>
//                                         <p style={{ color: "#555", lineHeight: 1.4, margin: 0 }}>{item.desc}</p>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>

//                         {/* Governance Panel */}
//                         <div
//                             style={
//                                 activeESGTab === "gov"
//                                     ? { display: "flex", flexDirection: "column", gap: "1.25rem", marginTop: "2rem" }
//                                     : { display: "none" }
//                             }
//                         >
//                             {[
//                                 { title: "CRISIL A-/Stable", desc: "Independent credit rating from S&P Global's CRISIL confirms strong financial health and low counterparty risk for long-term project partners." },
//                                 { title: "Anti-Corruption", desc: "Documented anti-bribery and anti-corruption policies governing all business operations, procurement, and external partnerships." },
//                                 { title: "ISO 9001", desc: "Certified quality management system ensuring consistent product standards, audit trails, and continuous improvement processes." },
//                                 { title: "Procurement Transparency", desc: "Full supply chain documentation available for lender, auditor, and procurement team review — enabling due diligence at every project stage." },
//                                 { title: "Creditworthy Partner", desc: "Ariel Re insured and CreditSafe rated B (Low Risk), providing bankability assurance for project finance and EPC partnerships." },
//                                 { title: "Regulatory Compliance", desc: "Fully compliant with GDPR, CCPA, Indian IT Act, and all applicable data protection and business conduct regulations." },
//                             ].map((item, idx) => (
//                                 <div
//                                     key={idx}
//                                     style={{ display: "flex", alignItems: "flex-start", gap: "1.5rem", backgroundColor: "#faf9f8", borderRadius: "20px", padding: "1.2rem 1.5rem", transition: "transform 0.2s" }}
//                                     className="esg-item-row"
//                                 >
//                                     <div style={{ fontSize: "2.5rem", fontWeight: 700, color: "#a20000", opacity: 0.5, lineHeight: 1, minWidth: "60px" }}>
//                                         {String(idx + 1).padStart(2, "0")}
//                                     </div>
//                                     <div style={{ flex: 1 }}>
//                                         <h4 style={{ fontSize: "1.2rem", marginBottom: "0.4rem" }}>{item.title}</h4>
//                                         <p style={{ color: "#555", lineHeight: 1.4, margin: 0 }}>{item.desc}</p>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </section>

//                 {/* Factories */}
//                 <section id="factories" style={styles.section}>
//                     <span style={{ ...styles.sectionEyebrow, color: "#a20000" }}>Manufacturing Footprint</span>
//                     <h2 style={styles.sectionTitle}>Made in <span style={{ color: "#a20000" }}>India. Only.</span></h2>
//                     <p style={styles.sectionLead}>Four factories. 5 GW module capacity. 3 GW cell manufacturing. 2 GW ingot & wafer by 2028.</p>
//                     <div style={styles.factories}>
//                         {[["Haridwar", "Plot 67–70, Sec 8A, SIDCUL, UK", "Solar Module"], ["Bhiwani", "7KM Milestone, Tosham Road, Haryana", "Solar Module"], ["Malanpur", "Malanpur Ind. Area, Nr. Gwalior, M.P.", "3 GW Cell"], ["Narmadapuram", "Bhopal, Madhya Pradesh", "2 GW Ingot"]].map((fac, i) => (
//                             <div key={i} className="factory-card" style={{ ...styles.factoryCard }}><div style={styles.factoryNum}>Factory 0{i + 1}{i === 3 ? " — Upcoming" : ""}</div><div style={styles.factoryName}>{fac[0]}</div><div style={styles.factoryLoc}>{fac[1]}</div><div style={styles.factoryCap}>{fac[2]}</div></div>
//                         ))}
//                     </div>
//                 </section>
//             </div>
//         </>
//     );
// };

// export default EsgComp;


import axios from "axios";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { FaLanguage } from "react-icons/fa";
import { RiLoader5Line } from "react-icons/ri";

// ============ TRANSLATIONS ============
const translations = {
    it: {
        navLinks: [
            { label: "Panoramica", href: "#overview" },
            { label: "NZIA & FER-X", href: "#nzia-ferx" },
            { label: "Moduli", href: "#products" },
            { label: "Tracciabilità", href: "#trace-cert" },
            { label: "ESG", href: "#esg" },
            { label: "Fabbriche", href: "#factories" },
        ],
        navCta: "Richiedi Info",
        hero: {
            eyebrow: "ESG & CONFORMITÀ",
            titleLine1: "Costruito per un",
            titleEm: "Responsabile",
            titleLine3: "Futuro Energetico",
            desc: "I moduli conformi NZIA e FER-X di Gautam Solar offrono tecnologia a celle non cinesi, tracciabile e allineata ESG — progettata per la nuova era degli appalti europei e per i mandati globali di approvvigionamento responsabile.",
        },
        stats: [
            { num: "5", span: "GW", label: "Produzione Moduli Solari in India" },
            { num: "3", span: "GW", label: "Produzione Celle in India" },
            { num: "29", span: "+", label: "Anni di Esperienza Solare" },
            { num: "A", span: "*", label: "Wood Mackenzie Grade A — H1 2025" },
        ],
        form: {
            eyebrow: "Richiedi Informazioni",
            title: "Parliamo del Tuo",
            titleEm: "Progetto",
            sub: "Compila il modulo sottostante e il nostro team di conformità ESG ti risponderà.",
            name: "Nome Completo",
            namePh: "Nome",
            email: "Indirizzo Email",
            emailPh: "Email",
            phone: "Numero di Telefono",
            phonePh: "Numero di Telefono",
            company: "Azienda / Organizzazione",
            companyPh: "Nome Azienda",
            designation: "Qualifica Aziendale",
            designationPh: "Seleziona qualifica",
            designationOptions: ["EPC", "Rivenditore", "Distributore", "Altro"],
            message: "Breve Messaggio",
            messagePh: "Raccontaci del tuo progetto, dei moduli richiesti o delle esigenze di documentazione di conformità...",
            submit: "Invia Richiesta →",
            success: "Grazie! La tua richiesta è stata ricevuta. Ti ricontatteremo presto.",
            required: "Si prega di compilare tutti i campi obbligatori (Nome, Email, Telefono).",
        },
        pillars: [
            { title: "Conforme al Lavoro Non Forzato", desc: "Distinta Base 100% tracciabile senza lavoro forzato nella catena di fornitura. Conforme UFLPA e FEOC." },
            { title: "Celle Non Cinesi con Tracciabilità", desc: "Celle N-Type TOPCon prodotte in India con origine verificata a ogni livello di componente." },
            { title: "Fabbrica e Catena di Fornitura Allineate ESG", desc: "Emissioni Scope 1, 2 e 3 ridotte. Operazioni certificate ISO 9001, 14001 e 45001 in tutti gli impianti." },
        ],
        compliance: {
            eyebrow: "Regolamento UE & FER-X Italiano",
            titleA: "NZIA & FER‑X ",
            titleB: "Hub di Conformità",
            lead: "Un unico standard integrato per la resilienza europea — Gautam Solar soddisfa sia i criteri non di prezzo NZIA che i requisiti FER-X italiani per componenti non cinesi.",
            nziaTitle: "Net Zero Industry Act (NZIA)",
            nziaDesc: "Adottato a maggio 2024. Gli Stati membri dell'UE applicano criteri non di prezzo – resilienza, sostenibilità, condotta responsabile delle imprese. Tolleranza per differenze di prezzo fino al 20%.",
            nziaCriteria: [
                "Contributo alla Resilienza — catena di fornitura non cinese",
                "Sostenibilità — Scope 1,2,3 ridotti, ISO 14001",
                "Condotta Responsabile delle Imprese — conformità al lavoro",
                "Tracciabilità della Catena di Fornitura — BOM 100% tracciabile",
                "Divulgazione ESG e documentazione di audit",
                "Materiali riciclabili e programmi di fine vita",
            ],
            ferxTitle: "🇮🇹 FER‑X (attuazione italiana NZIA)",
            ferxDesc: "Per progetti >1 MW: moduli non cinesi obbligatori. Prima asta aggiudicata 1,1 GW a €66,38/MWh. Gautam Solar si qualifica con 4+ componenti non cinesi.",
            ferxStats: [
                { num: "1,1 GW", label: "aggiudicati" },
                { num: "88", label: "progetti" },
                { num: "4+", label: "componenti non cinesi" },
            ],
            ferxItems: [
                { title: "Celle Solari", desc: "Celle N-Type TOPCon prodotte in India (3GW Malanpur)." },
                { title: "Assemblaggio Moduli", desc: "Capacità 5GW Haridwar e Bhiwani, certificate IEC/UL." },
                { title: "Documentazione BOM Completa", desc: "Cella, vetro, telaio, incapsulante – tracciabili e disponibili per GSE." },
            ],
        },
        products: {
            eyebrow: "Moduli Conformi NZIA & FER-X",
            titleA: "La Nostra Gamma di ",
            titleB: "Moduli Conformi",
            lead: "Tre serie N-Type TOPCon ad alte prestazioni, tutte conformi NZIA, certificate IEC/UL e completamente tracciabili.",
            badge: "Conforme NZIA",
            specs: { efficiency: "Efficienza", power: "Potenza", cells: "Celle", tempCoeff: "Coeff. Temp", certification: "Certificazione", warranty: "Garanzia" },
            tags: ["Celle Non Cinesi", "BOM Tracciabile"],
            items: [
                ["G12 R TOPCon", "N-Type · Cella Rettangolare · 620–640 Wp", "Fino a 23,69%", "620 – 640 Wp", "N-Type TOPCon 105×182mm", "−0,29%/°C", "Standard UL & IEC", "12 anni / 30 anni", "Ammissibile FER-X"],
                ["G12 TOPCon", "N-Type · Cella Standard · 690–720 Wp", "Fino a 23,20%", "690 – 720 Wp", "N-Type TOPCon 105×210mm", "−0,30%/°C", "Standard IEC CB", "12 anni / 30 anni", "Alta Potenza"],
                ["M10 R TOPCon", "N-Type · Grande Scala · 590–600 Wp", "Fino a 23,23%", "590 – 600 Wp", "N-Type TOPCon 91.8×182mm", "−0,30%/°C", "Standard UL & IEC", "12 anni / 30 anni", "Scala Utility"],
            ],
        },
        trace: {
            eyebrow: "Fiducia & Trasparenza",
            titleA: "Tracciabilità ",
            titleEm: "incontra ",
            titleB: "la Certificazione Globale",
            lead: "Tracciabilità a livello di componente al 100% + certificazioni leader del settore: bancabilità per ogni progetto.",
            bomTitle: "Distinta Base – completamente tracciabile",
            bomItems: [
                { title: "Cella Solare", desc: "Celle N-Type TOPCon prodotte in India. Non cinesi, non Xinjiang." },
                { title: "Vetro", desc: "2,0mm rivestito AR, alta trasmissione." },
                { title: "Incapsulante EVA/POE", desc: "PID Free, resistente ai raggi UV, tracciabile per lotto." },
                { title: "Junction Box", desc: "IP68, compatibile MC4." },
                { title: "Telaio & Ribbon", desc: "Alluminio anodizzato, certificazione completa dei materiali." },
            ],
            certTitle: "Conformità & Certificazioni",
            flags: [
                { title: "🇺🇸 UFLPA & FEOC", tags: ["Conforme UFLPA", "Conforme FEOC", "Documenti Catena Fornitura"] },
                { title: "🇪🇺 ESG Europa", tags: ["Due Diligence", "Report Carbonio", "Lavoro Non Forzato"] },
            ],
            certs: [
                { name: "Kiwa PVEL Top Performer", detail: "12ª Edizione · 2026" },
                { name: "Wood Mackenzie Grade A", detail: "Top 30 Globale, H1 2025" },
                { name: "IEC & IEC CB", detail: "Standard Internazionali" },
                { name: "UL Listed", detail: "Sicurezza cULus" },
                { name: "CRISIL A-/Stabile", detail: "Rating A2+" },
                { name: "Certificato CE", detail: "Conformità Europea" },
                { name: "ISO 9001/14001/45001", detail: "Gestione Q&A&SSL" },
                { name: "Certificato SGS", detail: "Ispezione di terze parti" },
            ],
        },
        esg: {
            eyebrow: "Quadro ESG",
            titleA: "Il Nostro Impegno ",
            titleEm: "Ambientale, Sociale &",
            titleB: "di Governance",
            lead: "Integrato nelle operazioni, nella catena di fornitura e nella produzione — non solo rendicontazione.",
            tabs: ["Ambientale", "Sociale", "Governance"],
            env: [
                { title: "Riduzione Emissioni Scope 1,2,3", desc: "Programmi attivi per ridurre le emissioni dirette, indirette e della catena del valore in tutti e quattro gli stabilimenti produttivi." },
                { title: "Certificato ISO 14001", desc: "Sistema di Gestione Ambientale certificato presso gli stabilimenti di Haridwar, Bhiwani e Malanpur." },
                { title: "Materiali Riciclabili", desc: "Il design dei moduli incorpora vetro riciclabile, telai in alluminio e incapsulanti, con programmi strutturati di ritiro e riciclo a fine vita." },
                { title: "Rendicontazione ESG", desc: "Divulgazioni complete sulla sostenibilità disponibili, inclusi dati sulle prestazioni ambientali allineati ai framework GRI e SASB." },
                { title: "Divulgazione Impronta di Carbonio", desc: "Report sul carbonio a livello di prodotto e di impianto disponibili per supportare gli obblighi di rendicontazione ESG di sviluppatori e finanziatori." },
                { title: "Approvvigionamento Responsabile", desc: "Tutte le materie prime acquistate con documentazione di origine verificata, dando priorità ai fornitori con certificazione ambientale." },
            ],
            soc: [
                { title: "BOM Lavoro Non Forzato", desc: "L'audit completo della catena di fornitura conferma l'assenza di lavoro forzato, vincolato o minorile a qualsiasi livello — conforme UFLPA e FEOC." },
                { title: "ISO 45001 SSL", desc: "Sistema di gestione della sicurezza dei lavoratori certificato in tutti gli stabilimenti produttivi." },
                { title: "Sviluppo della Comunità", desc: "Programmi CSR attivi tra cui donazione di attrezzature mediche all'AIIMS, campi sanitari, mobilità pulita e iniziative educative in tutta l'India." },
                { title: "Leadership Femminile", desc: "Promuoviamo la diversità di genere nella produzione solare, con leadership femminile riconosciuta a livello industriale nazionale." },
                { title: "Lavori Make in India", desc: "Produzione 100% in India, generando direttamente migliaia di posti di lavoro qualificati e semi-qualificati in Uttarakhand, Haryana e Madhya Pradesh." },
                { title: "Audit sul Lavoro dei Fornitori", desc: "Audit regolari di conformità sociale condotti lungo la catena di fornitura per mantenere gli standard a ogni livello." },
            ],
            gov: [
                { title: "CRISIL A-/Stabile", desc: "Il rating di credito indipendente di CRISIL di S&P Global conferma una solida salute finanziaria e un basso rischio di controparte per i partner di progetto a lungo termine." },
                { title: "Anti-Corruzione", desc: "Politiche documentate anti-corruzione e anti-concussione che governano tutte le operazioni commerciali, gli appalti e le partnership esterne." },
                { title: "ISO 9001", desc: "Sistema di gestione della qualità certificato che garantisce standard di prodotto coerenti, tracciabilità degli audit e processi di miglioramento continuo." },
                { title: "Trasparenza negli Appalti", desc: "Documentazione completa della catena di fornitura disponibile per la revisione da parte di finanziatori, revisori e team di approvvigionamento — consentendo la due diligence in ogni fase del progetto." },
                { title: "Partner Affidabile", desc: "Assicurato Ariel Re e valutato CreditSafe B (Basso Rischio), fornendo garanzie di bancabilità per il project finance e le partnership EPC." },
                { title: "Conformità Normativa", desc: "Pienamente conforme a GDPR, CCPA, Indian IT Act e tutte le normative applicabili sulla protezione dei dati e sulla condotta commerciale." },
            ],
        },
        factories: {
            eyebrow: "Impronta Produttiva",
            titleA: "Prodotto in ",
            titleB: "India. Solo.",
            lead: "Quattro fabbriche. 5 GW di capacità moduli. 3 GW di produzione celle. 2 GW di lingotti e wafer entro il 2028.",
            factory: "Fabbrica",
            upcoming: " — In Arrivo",
            items: [
                ["Haridwar", "Plot 67–70, Sec 8A, SIDCUL, UK", "Modulo Solare"],
                ["Bhiwani", "7KM Milestone, Tosham Road, Haryana", "Modulo Solare"],
                ["Malanpur", "Malanpur Ind. Area, Nr. Gwalior, M.P.", "3 GW Celle"],
                ["Narmadapuram", "Bhopal, Madhya Pradesh", "2 GW Lingotti"],
            ],
        },
        videoFallback: "Il tuo browser non supporta il tag video.",
    },
    en: {
        navLinks: [
            { label: "Overview", href: "#overview" },
            { label: "NZIA & FER-X", href: "#nzia-ferx" },
            { label: "Modules", href: "#products" },
            { label: "Traceability", href: "#trace-cert" },
            { label: "ESG", href: "#esg" },
            { label: "Factories", href: "#factories" },
        ],
        navCta: "Request Info",
        hero: {
            eyebrow: "ESG & COMPLIANCE",
            titleLine1: "Built for a",
            titleEm: "Responsible",
            titleLine3: "Energy Future",
            desc: "Gautam Solar's NZIA and FER-X compliant modules deliver traceable, ESG-aligned, non-Chinese cell technology — purpose-built for Europe's new procurement era and global responsible sourcing mandates.",
        },
        stats: [
            { num: "5", span: "GW", label: "Solar Module Mfg. in India" },
            { num: "3", span: "GW", label: "Cell Manufacturing in India" },
            { num: "29", span: "+", label: "Years of Solar Experience" },
            { num: "A", span: "*", label: "Wood Mackenzie Grade A — H1 2025" },
        ],
        form: {
            eyebrow: "Request Information",
            title: "Let's Discuss Your",
            titleEm: "Project Needs",
            sub: "Fill out the form below and our ESG compliance team will get back to you.",
            name: "Full Name",
            namePh: "Name",
            email: "Email Address",
            emailPh: "Email",
            phone: "Phone Number",
            phonePh: "Phone Number",
            company: "Company / Organisation",
            companyPh: "Company Name",
            designation: "Company Designation",
            designationPh: "Select designation",
            designationOptions: ["EPC", "Dealer", "Distributor", "Other"],
            message: "Short Message",
            messagePh: "Tell us about your project, required modules, or compliance documentation needs...",
            submit: "Send Enquiry →",
            success: "Thank you! Your enquiry has been received. We'll get back to you soon.",
            required: "Please fill in all required fields (Name, Email, Phone).",
        },
        pillars: [
            { title: "Non-Forced Labour Compliant", desc: "100% traceable Bill of Materials with no forced labour in the supply chain. UFLPA and FEOC compliant." },
            { title: "Non-Chinese Cells with Traceability", desc: "N-Type TOPCon cells manufactured in India with verified origin at every component level." },
            { title: "ESG Aligned Factory & Supply Chain", desc: "Reduced Scope 1, 2 & 3 emissions. ISO 9001, 14001 & 45001 certified operations across all plants." },
        ],
        compliance: {
            eyebrow: "EU Regulation & Italy's FER-X",
            titleA: "NZIA & FER‑X ",
            titleB: "Compliance Hub",
            lead: "One integrated standard for European resilience — Gautam Solar meets both NZIA non‑price criteria and Italy's FER‑X requirements for non‑Chinese components.",
            nziaTitle: "Net Zero Industry Act (NZIA)",
            nziaDesc: "Adopted May 2024. EU member states apply non-price criteria – resilience, sustainability, responsible business conduct. Tolerance for price differences up to 20%.",
            nziaCriteria: [
                "Resilience Contribution — non-Chinese supply chain",
                "Sustainability — reduced Scope 1,2,3, ISO 14001",
                "Responsible Business Conduct — labour compliance",
                "Supply Chain Traceability — 100% BOM traceable",
                "ESG Disclosure & audit documentation",
                "Recyclable materials & end-of-life programs",
            ],
            ferxTitle: "🇮🇹 FER‑X (Italy NZIA implementation)",
            ferxDesc: "For projects >1 MW: mandatory non-Chinese modules. First auction awarded 1.1 GW at €66.38/MWh. Gautam Solar qualifies with 4+ non-Chinese components.",
            ferxStats: [
                { num: "1.1 GW", label: "awarded" },
                { num: "88", label: "projects" },
                { num: "4+", label: "non‑Chinese components" },
            ],
            ferxItems: [
                { title: "Solar Cells", desc: "N-Type TOPCon cells made in India (3GW Malanpur)." },
                { title: "Module Assembly", desc: "5GW capacity Haridwar & Bhiwani, IEC/UL certified." },
                { title: "Full BOM documentation", desc: "Cell, glass, frame, encapsulant – traceable & available for GSE." },
            ],
        },
        products: {
            eyebrow: "NZIA & FER-X Compliant Modules",
            titleA: "Our Compliant ",
            titleB: "Module Range",
            lead: "Three high-performance N-Type TOPCon series, all NZIA-compliant, IEC/UL certified, and fully traceable.",
            badge: "NZIA Compliant",
            specs: { efficiency: "Efficiency", power: "Power", cells: "Cells", tempCoeff: "Temp Coeff", certification: "Certification", warranty: "Warranty" },
            tags: ["Non-Chinese Cells", "Traceable BOM"],
            items: [
                ["G12 R TOPCon", "N-Type · Rectangular Cell · 620–640 Wp", "Up to 23.69%", "620 – 640 Wp", "N-Type TOPCon 105×182mm", "−0.29%/°C", "UL & IEC Standards", "12 yr / 30 yr", "FER-X Eligible"],
                ["G12 TOPCon", "N-Type · Standard Cell · 690–720 Wp", "Up to 23.20%", "690 – 720 Wp", "N-Type TOPCon 105×210mm", "−0.30%/°C", "IEC CB Standards", "12 yr / 30 yr", "High-Power"],
                ["M10 R TOPCon", "N-Type · Large-Scale · 590–600 Wp", "Up to 23.23%", "590 – 600 Wp", "N-Type TOPCon 91.8×182mm", "−0.30%/°C", "UL & IEC Standards", "12 yr / 30 yr", "Utility-Scale"],
            ],
        },
        trace: {
            eyebrow: "Trust & Transparency",
            titleA: "Traceability ",
            titleEm: "meets ",
            titleB: "Global Certification",
            lead: "100% component‑level traceability + industry‑leading certifications: bankability for every project.",
            bomTitle: "Bill of Materials – fully traceable",
            bomItems: [
                { title: "Solar Cell", desc: "N-Type TOPCon cells made in India. Non-Chinese, non-Xinjiang." },
                { title: "Glass", desc: "2.0mm AR coated, high transmission." },
                { title: "EVA/POE Encapsulant", desc: "PID Free, UV resistant, batch traceable." },
                { title: "Junction Box", desc: "IP68, MC4 compatible." },
                { title: "Frame & Ribbon", desc: "Anodised aluminium, full material certification." },
            ],
            certTitle: "Compliance & Certifications",
            flags: [
                { title: "🇺🇸 UFLPA & FEOC", tags: ["UFLPA Compliant", "FEOC Compliant", "Supply Chain Docs"] },
                { title: "🇪🇺 Europe ESG", tags: ["Due Diligence", "Carbon Reporting", "Non-Forced Labour"] },
            ],
            certs: [
                { name: "Kiwa PVEL Top Performer", detail: "12th Edition · 2026" },
                { name: "Wood Mackenzie Grade A", detail: "Global Top 30, H1 2025" },
                { name: "IEC & IEC CB", detail: "Intl. Standards" },
                { name: "UL Listed", detail: "cULus Safety" },
                { name: "CRISIL A-/Stable", detail: "A2+ rating" },
                { name: "CE Certified", detail: "European Conformity" },
                { name: "ISO 9001/14001/45001", detail: "Q&E&OH Management" },
                { name: "SGS Certified", detail: "3rd party inspection" },
            ],
        },
        esg: {
            eyebrow: "ESG Framework",
            titleA: "Our ",
            titleEm: "Environmental, Social &",
            titleB: "Governance Commitments",
            lead: "Built into operations, supply chain, and manufacturing — not just reporting.",
            tabs: ["Environmental", "Social", "Governance"],
            env: [
                { title: "Scope 1,2,3 Emissions Reduction", desc: "Active programmes to reduce direct, indirect, and value chain emissions across all four manufacturing facilities." },
                { title: "ISO 14001 Certified", desc: "Environmental Management System certified across Haridwar, Bhiwani, and Malanpur manufacturing sites." },
                { title: "Recyclable Materials", desc: "Module design incorporates recyclable glass, aluminium frames, and encapsulants, with structured end-of-life take-back and recycling programs." },
                { title: "ESG Reporting", desc: "Comprehensive sustainability disclosures available including environmental performance data aligned with GRI and SASB frameworks." },
                { title: "Carbon Footprint Disclosure", desc: "Product-level and facility-level carbon reporting available to support developer and lender ESG reporting obligations." },
                { title: "Responsible Sourcing", desc: "All raw materials procured with verified origin documentation, prioritising suppliers with environmental certification." },
            ],
            soc: [
                { title: "Non-Forced Labour BOM", desc: "Complete supply chain audit confirms no forced, bonded, or child labour at any tier — UFLPA and FEOC compliant." },
                { title: "ISO 45001 OHS", desc: "Worker safety management system certified across all manufacturing facilities." },
                { title: "Community Development", desc: "Active CSR programmes including medical equipment donation to AIIMS, health camps, clean mobility, and education initiatives across India." },
                { title: "Women Leadership", desc: "Championing gender diversity in solar manufacturing, with women leadership recognised at national industry level." },
                { title: "Make in India Jobs", desc: "Manufacturing 100% in India, directly generating thousands of skilled and semi-skilled jobs in Uttarakhand, Haryana, and Madhya Pradesh." },
                { title: "Supplier Labour Audits", desc: "Regular social compliance audits conducted across the supply chain to maintain standards at every tier." },
            ],
            gov: [
                { title: "CRISIL A-/Stable", desc: "Independent credit rating from S&P Global's CRISIL confirms strong financial health and low counterparty risk for long-term project partners." },
                { title: "Anti-Corruption", desc: "Documented anti-bribery and anti-corruption policies governing all business operations, procurement, and external partnerships." },
                { title: "ISO 9001", desc: "Certified quality management system ensuring consistent product standards, audit trails, and continuous improvement processes." },
                { title: "Procurement Transparency", desc: "Full supply chain documentation available for lender, auditor, and procurement team review — enabling due diligence at every project stage." },
                { title: "Creditworthy Partner", desc: "Ariel Re insured and CreditSafe rated B (Low Risk), providing bankability assurance for project finance and EPC partnerships." },
                { title: "Regulatory Compliance", desc: "Fully compliant with GDPR, CCPA, Indian IT Act, and all applicable data protection and business conduct regulations." },
            ],
        },
        factories: {
            eyebrow: "Manufacturing Footprint",
            titleA: "Made in ",
            titleB: "India. Only.",
            lead: "Four factories. 5 GW module capacity. 3 GW cell manufacturing. 2 GW ingot & wafer by 2028.",
            factory: "Factory",
            upcoming: " — Upcoming",
            items: [
                ["Haridwar", "Plot 67–70, Sec 8A, SIDCUL, UK", "Solar Module"],
                ["Bhiwani", "7KM Milestone, Tosham Road, Haryana", "Solar Module"],
                ["Malanpur", "Malanpur Ind. Area, Nr. Gwalior, M.P.", "3 GW Cell"],
                ["Narmadapuram", "Bhopal, Madhya Pradesh", "2 GW Ingot"],
            ],
        },
        videoFallback: "Your browser does not support the video tag.",
    },
};

const EsgComp = () => {
    const [activeESGTab, setActiveESGTab] = useState("env");
    const [language, setLanguage] = useState("it"); // default Italian
    const t = translations[language];

    const styles = {
        container: {
            fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
            color: "#111",
            backgroundColor: "#fff",
            lineHeight: 1.5,
            scrollBehavior: "smooth",
            overflow: 'hidden'
        },
        langSwitcher: {
            position: "fixed",
            top: "100px",
            right: "0",
            zIndex: 200,
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            backgroundColor: "#fff",
            borderRadius: "30px",
            padding: "0.35rem 0.75rem",
            boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
            border: "1px solid #eaeaea",
        },
        langLabel: { fontSize: "0.75rem", fontWeight: 600, color: "#555", textTransform: "uppercase", letterSpacing: "0.5px" },
        langSelect: {
            border: "1px solid #ddd", borderRadius: "20px", padding: "0.3rem 0.6rem",
            fontSize: "0.85rem", fontWeight: 600, fontFamily: "'Inter', sans-serif",
            backgroundColor: "#fff", cursor: "pointer", outline: "none", color: "#111",
        },
        nav: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "1rem 5%",
            backgroundColor: "#fff",
            borderBottom: "1px solid #eaeaea",
            position: "sticky",
            top: 0,
            zIndex: 100,
        },
        navLogo: { display: "flex", alignItems: "center", gap: "0.75rem" },
        navLogoMark: {
            width: "32px", height: "32px", backgroundColor: "#a20000", borderRadius: "6px",
            display: "flex", alignItems: "center", justifyContent: "center",
        },
        navLogoMarkSvg: { width: "20px", height: "20px", fill: "white" },
        navLogoText: { fontWeight: 700, fontSize: "1.25rem", letterSpacing: "-0.5px", color: "#111" },
        navLinks: {
            display: "flex", gap: "clamp(1rem, 2vw, 2rem)", alignItems: "center", flexWrap: "wrap",
        },
        navLink: {
            textDecoration: "none", color: "#333", fontSize: "0.9rem", fontWeight: 500, transition: "color 0.2s",
        },
        navCta: {
            backgroundColor: "#a20000", color: "white", padding: "0.5rem 1.2rem", borderRadius: "30px",
            textDecoration: "none", fontWeight: 600, fontSize: "0.9rem", transition: "all 0.2s",
        },
        hero: {
            display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "center",
            padding: "4rem 5%", gap: "3rem", backgroundColor: "#faf9f8", minHeight: '100vh',
            position: "relative", overflow: "hidden",
        },
        heroLeft: {
            flex: "1 1 480px", display: "flex", flexDirection: "column", gap: "2.5rem",
            position: "relative", zIndex: 2,
        },
        heroContent: { width: "100%" },
        heroEyebrow: {
            display: "flex", alignItems: "center", gap: "0.5rem", color: "#a20000",
            fontWeight: 600, fontSize: "0.8rem", textTransform: "uppercase",
            letterSpacing: "1px", marginBottom: "1rem",
        },
        heroEyebrowDot: {
            width: "8px", height: "8px", backgroundColor: "#a20000", borderRadius: "50%", display: "inline-block",
        },
        heroH1: {
            fontSize: "clamp(2.5rem, 6vw, 4rem)", fontFamily: "'DM Serif Display', serif",
            lineHeight: 1.1, marginBottom: "1rem", fontWeight: 400,
        },
        heroEm: { color: "#a20000", fontStyle: "normal" },
        heroDesc: { fontSize: "1.1rem", color: "#2b2b2b", maxWidth: "550px", marginBottom: "2rem" },
        heroStats: {
            width: "100%", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))", gap: "1rem",
        },
        statItem: {
            textAlign: "center", backgroundColor: "#fff", padding: "1.2rem 0.8rem",
            borderRadius: "20px", boxShadow: "0 4px 12px rgba(0,0,0,0.05)", transition: "transform 0.2s",
        },
        statNum: { fontSize: "2.2rem", fontWeight: 700, color: "#111", lineHeight: 1 },
        statNumSpan: { fontSize: "1rem", fontWeight: 400, color: "#666" },
        statLabel: { fontSize: "0.85rem", color: "#555", marginTop: "0.5rem" },
        heroRight: { flex: "1 1 420px", maxWidth: "560px", position: "relative", zIndex: 2 },
        formCard: {
            backgroundColor: "#fff", borderRadius: "28px", padding: "2rem",
            boxShadow: "0 12px 40px rgba(0,0,0,0.12)", border: "1px solid rgba(162,0,0,0.08)",
        },
        formHeader: { textAlign: "center", marginBottom: "1.5rem" },
        formTitle: {
            fontSize: "clamp(1.4rem, 3vw, 1.75rem)", fontFamily: "'DM Serif Display', serif",
            marginBottom: "0.4rem", lineHeight: 1.2,
        },
        formSub: { fontSize: "0.9rem", color: "#555", margin: 0 },
        formRow: { display: "flex", flexWrap: "wrap", gap: "1rem", marginBottom: "1rem" },
        formGroup: { flex: "1 1 180px", display: "flex", flexDirection: "column", gap: "0.4rem" },
        label: { fontWeight: 600, fontSize: "0.8rem", color: "#333" },
        input: {
            padding: "0.7rem 0.9rem", border: "1px solid #ddd", borderRadius: "14px",
            fontSize: "0.95rem", fontFamily: "'Inter', sans-serif", transition: "border 0.2s",
            outline: "none", backgroundColor: "#fff",
        },
        select: {
            padding: "0.7rem 0.9rem", border: "1px solid #ddd", borderRadius: "14px",
            fontSize: "0.95rem", fontFamily: "'Inter', sans-serif", outline: "none",
            backgroundColor: "#fff", cursor: "pointer",
        },
        textarea: {
            padding: "0.7rem 0.9rem", border: "1px solid #ddd", borderRadius: "14px",
            fontSize: "0.95rem", fontFamily: "'Inter', sans-serif", resize: "vertical",
            minHeight: "80px", outline: "none",
        },
        submitBtn: {
            backgroundColor: "#a20000", color: "white", padding: "0.8rem 2rem", border: "none",
            borderRadius: "40px", fontWeight: 600, fontSize: "1rem", cursor: "pointer",
            transition: "all 0.2s", width: "100%", marginTop: "0.5rem",
            display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem",
        },
        pillars: {
            display: "flex", flexWrap: "wrap", justifyContent: "space-between", gap: "2rem",
            padding: "3rem 5%", backgroundColor: "#fff", borderBottom: "1px solid #eee",
        },
        pillar: { flex: "1 1 250px", display: "flex", gap: "1rem", alignItems: "flex-start" },
        pillarIcon: {
            width: "44px", height: "44px", backgroundColor: "#f0f0f0", borderRadius: "12px",
            display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
        },
        pillarIconSvg: { width: "24px", height: "24px", stroke: "#a20000", fill: "none", strokeWidth: "1.5" },
        pillarTitle: { fontWeight: 700, fontSize: "1.1rem", marginBottom: "0.3rem" },
        pillarDesc: { fontSize: "0.9rem", color: "#555", lineHeight: 1.4 },
        section: { padding: "4rem 5%", maxWidth: "1400px", margin: "0 auto" },
        sectionEyebrow: {
            display: "inline-block", color: "#a20000", fontWeight: 600, fontSize: "0.8rem",
            textTransform: "uppercase", letterSpacing: "1px", marginBottom: "1rem",
        },
        sectionTitle: {
            fontSize: "clamp(1.8rem, 4vw, 2.5rem)", fontFamily: "'DM Serif Display', serif",
            marginBottom: "1rem", lineHeight: 1.2,
        },
        sectionLead: { fontSize: "1.1rem", color: "#444", maxWidth: "800px", marginBottom: "3rem" },
        complianceDual: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(340px,1fr))", gap: "2.5rem" },
        complianceCard: {
            backgroundColor: "#faf9f8", borderRadius: "28px", padding: "2rem",
            transition: "transform 0.2s", height: "100%",
        },
        nziaCriteria: { display: "flex", flexDirection: "column", gap: "1rem", marginTop: "1.2rem" },
        criteriaItem: { display: "flex", alignItems: "center", gap: "0.8rem" },
        criteriaCheck: {
            width: "22px", height: "22px", backgroundColor: "#a20000", borderRadius: "50%",
            display: "inline-flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
        },
        criteriaCheckSvg: { width: "12px", height: "12px", stroke: "white", strokeWidth: "2", fill: "none" },
        ferxStatsRow: { display: "flex", gap: "1rem", marginTop: "1.5rem", flexWrap: "wrap", justifyContent: "space-between" },
        ferxStat: { textAlign: "center", flex: 1 },
        ferxStatNum: { fontSize: "1.8rem", fontWeight: 700, color: "#a20000" },
        ferxComplianceGrid: { display: "grid", gap: "1rem", marginTop: "1rem" },
        ferxComplianceItem: { borderLeft: "3px solid #a20000", paddingLeft: "1rem" },
        productsGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px,1fr))", gap: "2rem" },
        productCard: {
            border: "1px solid #e0e0e0", borderRadius: "24px", padding: "1.5rem",
            backgroundColor: "#fff", transition: "all 0.25s", boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
        },
        productBadge: {
            display: "inline-block", backgroundColor: "#a20000", color: "white",
            fontSize: "0.7rem", padding: "0.2rem 0.6rem", borderRadius: "20px", marginBottom: "1rem",
        },
        productName: { fontSize: "1.6rem", fontWeight: 700, fontFamily: "'DM Serif Display', serif" },
        productSub: { color: "#666", marginBottom: "1rem", fontSize: "0.9rem" },
        productSpec: {
            display: "flex", justifyContent: "space-between", borderTop: "1px solid #eee",
            padding: "0.7rem 0", fontSize: "0.85rem",
        },
        specKey: { color: "#555" },
        specVal: { fontWeight: 500, color: "#111" },
        highlight: { color: "#a20000", fontWeight: 700 },
        productFooter: { display: "flex", flexWrap: "wrap", gap: "0.5rem", marginTop: "1rem" },
        productTag: {
            fontSize: "0.7rem", backgroundColor: "#f0f0f0", padding: "0.2rem 0.6rem",
            borderRadius: "20px", color: "#333",
        },
        greenTag: { backgroundColor: "#e6f4ea", color: "#2e7d32" },
        twoColumnLayout: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(360px,1fr))", gap: "2.5rem", marginTop: "1rem" },
        bomChain: { display: "flex", flexDirection: "column", gap: "1.2rem" },
        bomItem: { display: "flex", gap: "1rem", alignItems: "flex-start" },
        bomDot: {
            width: "28px", height: "28px", backgroundColor: "#a20000", borderRadius: "8px",
            display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
        },
        bomDotSvg: { width: "14px", height: "14px", stroke: "white", strokeWidth: "2", fill: "none" },
        complianceFlags: { display: "grid", gap: "1rem" },
        flagCard: { backgroundColor: "#f5f5f5", borderRadius: "16px", padding: "1.2rem", transition: "transform 0.2s" },
        flagTags: { display: "flex", flexWrap: "wrap", gap: "0.5rem", marginTop: "0.8rem" },
        flagTag: {
            backgroundColor: "#fff", padding: "0.2rem 0.8rem", borderRadius: "30px",
            fontSize: "0.75rem", border: "1px solid #ddd",
        },
        certsGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(190px,1fr))", gap: "1.2rem", marginTop: "1rem" },
        certCard: {
            backgroundColor: "#fff", border: "1px solid #eee", borderRadius: "20px",
            padding: "1.2rem", textAlign: "center", transition: "all 0.25s",
            boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
        },
        certIcon: {
            width: "40px", height: "40px", margin: "0 auto 0.8rem",
            fill: "none", stroke: "#a20000", strokeWidth: "1.5",
        },
        certName: { fontWeight: 700, marginBottom: "0.3rem", fontSize: "0.9rem" },
        certDetail: { fontSize: "0.75rem", color: "#666" },
        esgTabsContainer: { marginTop: "2rem" },
        esgTabs: {
            display: "flex", gap: "1rem", borderBottom: "2px solid #eee",
            marginBottom: "2rem", flexWrap: "wrap",
        },
        esgTab: {
            padding: "0.8rem 1.5rem", cursor: "pointer", fontWeight: 600,
            color: "#666", transition: "all 0.2s", borderBottom: "2px solid transparent",
        },
        activeEsgTab: { color: "#a20000", borderBottomColor: "#a20000" },
        factories: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px,1fr))", gap: "1.5rem", marginTop: "2rem" },
        factoryCard: { backgroundColor: "#a20000", color: "white", padding: "1.5rem", borderRadius: "24px", transition: "transform 0.2s" },
        factoryNum: { fontSize: "0.8rem", color: "#ffffff", marginBottom: "0.5rem" },
        factoryName: { fontSize: "1.6rem", fontWeight: 700, fontFamily: "'DM Serif Display', serif", marginBottom: "0.25rem" },
        factoryLoc: { fontSize: "0.8rem", color: "#ffffff", marginBottom: "1rem" },
        factoryCap: { fontWeight: 700, fontSize: "1.1rem" },
        divider: { height: "1px", backgroundColor: "#eee", margin: "0 5%" },
    };

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        companyName: "",
        companyDesignation: "",
        message: "",
    });
    const [loading, setLoading] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);
            let utm = localStorage.getItem('utm_data') || null;

            if (!formData.name || !formData.email || !formData.phone) {
                alert(t.form.required);
                return;
            }

            formData.utm = utm

            await axios.post('https://gautamsolar.us/interSolar-contact', formData);

            alert(t.form.success);
            setFormData({ name: "", email: "", phone: "", message: "", companyName: '', companyDesignation: '' });

        } catch (er) {
            console.log(er)
        }
        finally {
            setLoading(false)
        }
    };

    return (
        <>
            <Helmet>
                <title>ESG & Compliance | Responsible Solar Manufacturing | Gautam Solar</title>
                <meta name="description" content="Explore Gautam Solar's ESG and compliance initiatives, including NZIA and FER-X compliant solar modules, traceable supply chains, responsible sourcing, emissions reduction and certified manufacturing." />
                <link rel="canonical" href="https://gautamsolar.com/esg/" />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="ESG & Compliance | Responsible Solar Manufacturing | Gautam Solar" />
                <meta property="og:description" content="Explore Gautam Solar's ESG and compliance initiatives, including NZIA and FER-X compliant solar modules, traceable supply chains, responsible sourcing, emissions reduction and certified manufacturing." />
                <meta property="og:url" content="https://gautamsolar.com/esg/" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Gautam Solar" />

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        "@id": "https://gautamsolar.com/#organization",
                        "name": "Gautam Solar",
                        "url": "https://gautamsolar.com/esg/",
                        "telephone": "+91 93117 97248",
                        "email": "info@gautamsolar.com",
                        "address": { "@type": "PostalAddress", "streetAddress": "D-120-121, Okhla Industrial Area, Phase-1", "addressLocality": "New Delhi", "addressCountry": "IN" },
                        "sameAs": ["https://www.linkedin.com/company/gautam-solar", "https://www.facebook.com/GautamSolar", "https://twitter.com/GautamSolar", "https://www.instagram.com/gautamsolar"]
                    })}
                </script>

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "WebSite",
                        "@id": "https://gautamsolar.com/#website",
                        "url": "https://gautamsolar.com/esg/",
                        "name": "Gautam Solar",
                        "publisher": { "@id": "https://gautamsolar.com/#organization" }
                    })}
                </script>

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "WebPage",
                        "@id": "https://gautamsolar.com/esg/#webpage",
                        "url": "https://gautamsolar.com/esg/",
                        "name": "ESG & Compliance | Responsible Solar Manufacturing | Gautam Solar",
                        "description": "Gautam Solar's ESG and compliance initiatives covering NZIA and FER-X compliance, supply chain traceability, responsible sourcing, emissions reduction, certified operations and ESG commitments.",
                        "inLanguage": "en",
                        "isPartOf": { "@id": "https://gautamsolar.com/#website" },
                        "publisher": { "@id": "https://gautamsolar.com/#organization" },
                        "about": [
                            { "@type": "Thing", "name": "ESG and Compliance" },
                            { "@type": "Thing", "name": "Responsible Solar Manufacturing" },
                            { "@type": "Thing", "name": "Solar Supply Chain Traceability" },
                            { "@type": "Thing", "name": "NZIA Compliance" },
                            { "@type": "Thing", "name": "FER-X Compliance" }
                        ],
                        "breadcrumb": { "@id": "https://gautamsolar.com/esg/#breadcrumb" }
                    })}
                </script>

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "ItemList",
                        "@id": "https://gautamsolar.com/esg/#module-range",
                        "name": "NZIA Compliant Gautam Solar Module Range",
                        "description": "Gautam Solar's N-Type TOPCon module range displayed on its ESG and Compliance page.",
                        "numberOfItems": 3,
                        "itemListElement": [
                            { "@type": "ListItem", "position": 1, "item": { "@type": "Product", "name": "G12 R TOPCon", "brand": { "@type": "Brand", "name": "Gautam Solar" }, "category": "N-Type TOPCon Solar Module", "description": "N-Type rectangular-cell TOPCon solar module with 620–640 Wp power, efficiency up to 23.69%, UL and IEC standards, and traceable non-Chinese cells.", "additionalProperty": [{ "@type": "PropertyValue", "name": "Technology", "value": "N-Type TOPCon" }, { "@type": "PropertyValue", "name": "Power", "value": "620–640 Wp" }, { "@type": "PropertyValue", "name": "Efficiency", "value": "Up to 23.69%" }, { "@type": "PropertyValue", "name": "Cell Size", "value": "105×182 mm" }, { "@type": "PropertyValue", "name": "Temperature Coefficient", "value": "-0.29%/°C" }, { "@type": "PropertyValue", "name": "Certification", "value": "UL & IEC Standards" }, { "@type": "PropertyValue", "name": "Warranty", "value": "12 year / 30 year" }] } },
                            { "@type": "ListItem", "position": 2, "item": { "@type": "Product", "name": "G12 TOPCon", "brand": { "@type": "Brand", "name": "Gautam Solar" }, "category": "N-Type TOPCon Solar Module", "description": "N-Type standard-cell TOPCon solar module with 690–720 Wp power, efficiency up to 23.20%, IEC CB standards and traceable non-Chinese cells.", "additionalProperty": [{ "@type": "PropertyValue", "name": "Technology", "value": "N-Type TOPCon" }, { "@type": "PropertyValue", "name": "Power", "value": "690–720 Wp" }, { "@type": "PropertyValue", "name": "Efficiency", "value": "Up to 23.20%" }, { "@type": "PropertyValue", "name": "Cell Size", "value": "105×210 mm" }, { "@type": "PropertyValue", "name": "Temperature Coefficient", "value": "-0.30%/°C" }, { "@type": "PropertyValue", "name": "Certification", "value": "IEC CB Standards" }, { "@type": "PropertyValue", "name": "Warranty", "value": "12 year / 30 year" }] } },
                            { "@type": "ListItem", "position": 3, "item": { "@type": "Product", "name": "M10 R TOPCon", "brand": { "@type": "Brand", "name": "Gautam Solar" }, "category": "N-Type TOPCon Solar Module", "description": "N-Type large-scale TOPCon solar module with 590–600 Wp power, efficiency up to 23.23%, UL and IEC standards and traceable non-Chinese cells.", "additionalProperty": [{ "@type": "PropertyValue", "name": "Technology", "value": "N-Type TOPCon" }, { "@type": "PropertyValue", "name": "Power", "value": "590–600 Wp" }, { "@type": "PropertyValue", "name": "Efficiency", "value": "Up to 23.23%" }, { "@type": "PropertyValue", "name": "Cell Size", "value": "91.8×182 mm" }, { "@type": "PropertyValue", "name": "Temperature Coefficient", "value": "-0.30%/°C" }, { "@type": "PropertyValue", "name": "Certification", "value": "UL & IEC Standards" }, { "@type": "PropertyValue", "name": "Warranty", "value": "12 year / 30 year" }] } }
                        ]
                    })}
                </script>

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "BreadcrumbList",
                        "@id": "https://gautamsolar.com/esg/#breadcrumb",
                        "itemListElement": [
                            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://gautamsolar.com/" },
                            { "@type": "ListItem", "position": 2, "name": "ESG & Compliance", "item": "https://gautamsolar.com/esg/" }
                        ]
                    })}
                </script>
            </Helmet>

            <div style={styles.container}>
                <style>{`
        .esg-comp-wrapper a, .esg-comp-wrapper button { cursor: pointer; }
        .esg-comp-wrapper .nav-link:hover { color: #a20000 !important; }
        .esg-comp-wrapper .nav-cta:hover, .esg-comp-wrapper .btn-primary:hover { background-color: #a20000 !important; transform: translateY(-2px); }
        .esg-comp-wrapper .stat-item:hover, .esg-comp-wrapper .product-card:hover, .esg-comp-wrapper .cert-card:hover { transform: translateY(-4px); box-shadow: 0 12px 24px rgba(0,0,0,0.1); }
        .esg-comp-wrapper .compliance-card:hover, .esg-comp-wrapper .flag-card:hover { transform: translateY(-3px); }
        .esg-comp-wrapper .factory-card:hover { transform: translateY(-6px); background-color: #1a1a1a !important; }
        .esg-comp-wrapper .esg-item-row:hover { transform: translateY(-3px); }
        .esg-comp-wrapper .submit-btn:hover:not(:disabled) { background-color: #8a0000 !important; transform: translateY(-2px); }
        @media (max-width: 768px) {
          .esg-comp-wrapper nav { flex-direction: column; gap: 1rem; }
        }
      `}</style>

                {/* Language Switcher */}
                <div style={styles.langSwitcher}>
                    <span style={styles.langLabel}><FaLanguage size='25'/></span>
                    <select
                        value={language}
                        onChange={(e) => setLanguage(e.target.value)}
                        style={styles.langSelect}
                        aria-label="Select language"
                    >
                        <option value="it">Italiano</option>
                        <option value="en">English</option>
                    </select>
                </div>

                {/* ============ HERO ============ */}
                <div style={styles.hero}>
                    <video autoPlay loop muted playsInline style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover", zIndex: 0, opacity: 0.3 }}>
                        <source src="/2025_Factory_Video1.mp4" type="video/mp4" />
                        {t.videoFallback}
                    </video>

                    <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0, 0, 0, 0.28)", zIndex: 1 }} />

                    <div style={styles.heroLeft}>
                        <div style={styles.heroContent}>
                            <div style={styles.heroEyebrow}>
                                <span style={styles.heroEyebrowDot}></span> {t.hero.eyebrow}
                            </div>
                            <h1 style={styles.heroH1}>
                                {t.hero.titleLine1}<br />
                                <span style={styles.heroEm}>{t.hero.titleEm}</span>
                                <br />{t.hero.titleLine3}
                            </h1>
                            <p style={styles.heroDesc}>{t.hero.desc}</p>
                        </div>

                        <div style={styles.heroStats}>
                            {t.stats.map((s, i) => (
                                <div key={i} className="stat-item" style={styles.statItem}>
                                    <div style={styles.statNum}>{s.num}<span style={styles.statNumSpan}>{s.span}</span></div>
                                    <div style={styles.statLabel}>{s.label}</div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div style={styles.heroRight}>
                        <div style={styles.formCard}>
                            <div style={styles.formHeader}>
                                <span style={{ ...styles.sectionEyebrow, marginBottom: "0.5rem" }}>{t.form.eyebrow}</span>
                                <h2 style={styles.formTitle}>{t.form.title} <span style={styles.heroEm}>{t.form.titleEm}</span></h2>
                                <p style={styles.formSub}>{t.form.sub}</p>
                            </div>

                            <form onSubmit={handleSubmit}>
                                <div style={styles.formRow}>
                                    <div style={styles.formGroup}>
                                        <label style={styles.label}>{t.form.name} <span style={{ color: "#a20000" }}>*</span></label>
                                        <input type="text" name="name" value={formData.name} onChange={handleInputChange} style={styles.input} placeholder={t.form.namePh} required />
                                    </div>
                                    <div style={styles.formGroup}>
                                        <label style={styles.label}>{t.form.email} <span style={{ color: "#a20000" }}>*</span></label>
                                        <input type="email" name="email" value={formData.email} onChange={handleInputChange} style={styles.input} placeholder={t.form.emailPh} required />
                                    </div>
                                </div>

                                <div style={styles.formRow}>
                                    <div style={styles.formGroup}>
                                        <label style={styles.label}>{t.form.phone} <span style={{ color: "#a20000" }}>*</span></label>
                                        <input type="tel" name="phone" value={formData.phone} onChange={handleInputChange} style={styles.input} placeholder={t.form.phonePh} required />
                                    </div>
                                    <div style={styles.formGroup}>
                                        <label style={styles.label}>{t.form.company}</label>
                                        <input type="text" name="companyName" value={formData.companyName} onChange={handleInputChange} style={styles.input} placeholder={t.form.companyPh} required />
                                    </div>
                                </div>

                                <div style={styles.formRow}>
                                    <div style={{ ...styles.formGroup, flex: "1 1 100%" }}>
                                        <label style={styles.label}>{t.form.designation}</label>
                                        <select name="companyDesignation" value={formData.companyDesignation} onChange={handleInputChange} style={styles.select} required>
                                            <option value="">{t.form.designationPh}</option>
                                            {t.form.designationOptions.map((opt, i) => (
                                                <option key={i} value={opt}>{opt}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div style={{ ...styles.formGroup, marginBottom: "1rem" }}>
                                    <label style={styles.label}>{t.form.message}</label>
                                    <textarea name="message" value={formData.message} onChange={handleInputChange} style={styles.textarea} placeholder={t.form.messagePh} />
                                </div>

                                <button type="submit" disabled={loading} className="submit-btn" style={{ ...styles.submitBtn, cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1 }}>
                                    {loading ? <RiLoader5Line size={28} style={{ animation: "spin 1s linear infinite" }} /> : t.form.submit}
                                </button>

                                <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                            </form>
                        </div>
                    </div>
                </div>

                {/* Pillars */}
                <div style={styles.pillars}>
                    <div style={styles.pillar}><div style={styles.pillarIcon}><svg viewBox="0 0 24 24" style={styles.pillarIconSvg}><path d="M9 12l2 2 4-4M12 3C7 3 3 7 3 12s4 9 9 9 9-4 9-9-4-9-9-9z" strokeLinecap="round" strokeLinejoin="round" /></svg></div><div><div style={styles.pillarTitle}>{t.pillars[0].title}</div><div style={styles.pillarDesc}>{t.pillars[0].desc}</div></div></div>
                    <div style={styles.pillar}><div style={styles.pillarIcon}><svg viewBox="0 0 24 24" style={styles.pillarIconSvg}><path d="M3 3h18v18H3zM3 9h18M9 21V9" strokeLinecap="round" strokeLinejoin="round" /></svg></div><div><div style={styles.pillarTitle}>{t.pillars[1].title}</div><div style={styles.pillarDesc}>{t.pillars[1].desc}</div></div></div>
                    <div style={styles.pillar}><div style={styles.pillarIcon}><svg viewBox="0 0 24 24" style={styles.pillarIconSvg}><path d="M12 3v4m0 10v4M3 12h4m10 0h4M6.34 6.34l2.83 2.83m5.66 5.66l2.83 2.83M6.34 17.66l2.83-2.83m5.66-5.66l2.83-2.83" strokeLinecap="round" strokeLinejoin="round" /></svg></div><div><div style={styles.pillarTitle}>{t.pillars[2].title}</div><div style={styles.pillarDesc}>{t.pillars[2].desc}</div></div></div>
                </div>

                {/* NZIA + FER-X */}
                <section id="nzia-ferx" style={styles.section}>
                    <span style={styles.sectionEyebrow}>{t.compliance.eyebrow}</span>
                    <h2 style={styles.sectionTitle}>{t.compliance.titleA}<span style={styles.heroEm}>{t.compliance.titleB}</span></h2>
                    <p style={styles.sectionLead}>{t.compliance.lead}</p>
                    <div style={styles.complianceDual}>
                        <div className="compliance-card" style={styles.complianceCard}>
                            <h3>{t.compliance.nziaTitle}</h3>
                            <p>{t.compliance.nziaDesc}</p>
                            <div style={styles.nziaCriteria}>
                                {t.compliance.nziaCriteria.map((text, i) => (
                                    <div key={i} style={styles.criteriaItem}><div style={styles.criteriaCheck}><svg viewBox="0 0 12 12" style={styles.criteriaCheckSvg}><polyline points="2,6 5,9 10,3" /></svg></div><span>{text}</span></div>
                                ))}
                            </div>
                        </div>
                        <div className="compliance-card" style={styles.complianceCard}>
                            <h3>{t.compliance.ferxTitle}</h3>
                            <p>{t.compliance.ferxDesc}</p>
                            <div style={styles.ferxStatsRow}>
                                {t.compliance.ferxStats.map((s, i) => (
                                    <div key={i} style={styles.ferxStat}><div style={styles.ferxStatNum}>{s.num}</div><div>{s.label}</div></div>
                                ))}
                            </div>
                            <div style={styles.ferxComplianceGrid}>
                                {t.compliance.ferxItems.map((item, i) => (
                                    <div key={i} style={styles.ferxComplianceItem}><h5>{item.title}</h5><p>{item.desc}</p></div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>
                <div style={styles.divider}></div>

                {/* Products */}
                <section id="products" style={styles.section}>
                    <span style={{ ...styles.sectionEyebrow, color: "#a20000" }}>{t.products.eyebrow}</span>
                    <h2 style={styles.sectionTitle}>{t.products.titleA}<span style={{ color: "#a20000" }}>{t.products.titleB}</span></h2>
                    <p style={styles.sectionLead}>{t.products.lead}</p>
                    <div style={styles.productsGrid}>
                        {t.products.items.map((prod, i) => (
                            <div key={i} className="product-card" style={styles.productCard}>
                                <div style={styles.productBadge}>{t.products.badge}</div>
                                <div style={styles.productName}>{prod[0]}</div><div style={styles.productSub}>{prod[1]}</div>
                                <div style={styles.productSpec}><span style={styles.specKey}>{t.products.specs.efficiency}</span><span style={{ ...styles.specVal, ...styles.highlight }}>{prod[2]}</span></div>
                                <div style={styles.productSpec}><span>{t.products.specs.power}</span><span>{prod[3]}</span></div>
                                <div style={styles.productSpec}><span>{t.products.specs.cells}</span><span>{prod[4]}</span></div>
                                <div style={styles.productSpec}><span>{t.products.specs.tempCoeff}</span><span>{prod[5]}</span></div>
                                <div style={styles.productSpec}><span>{t.products.specs.certification}</span><span>{prod[6]}</span></div>
                                <div style={styles.productSpec}><span>{t.products.specs.warranty}</span><span>{prod[7]}</span></div>
                                <div style={styles.productFooter}><span style={{ ...styles.productTag, ...styles.greenTag }}>{t.products.tags[0]}</span><span style={styles.productTag}>{t.products.tags[1]}</span><span style={styles.productTag}>{prod[8]}</span></div>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Traceability + Certifications */}
                <section id="trace-cert" style={styles.section}>
                    <span style={styles.sectionEyebrow}>{t.trace.eyebrow}</span>
                    <h2 style={styles.sectionTitle}>{t.trace.titleA}<span style={styles.heroEm}>{t.trace.titleEm}</span>{t.trace.titleB}</h2>
                    <p style={styles.sectionLead}>{t.trace.lead}</p>
                    <div style={styles.twoColumnLayout}>
                        <div>
                            <h3 style={{ fontFamily: "'DM Serif Display', serif", marginBottom: "1.2rem" }}>{t.trace.bomTitle}</h3>
                            <div style={styles.bomChain}>
                                {t.trace.bomItems.map((item, i) => (
                                    <div key={i} style={styles.bomItem}><div style={styles.bomDot}><svg viewBox="0 0 14 14" style={styles.bomDotSvg}>{i === 0 ? <circle cx="7" cy="7" r="4" /> : i === 1 ? <rect x="2" y="2" width="10" height="10" rx="1" /> : <path d="M2 2h10v10H2z" />}</svg></div><div><h5>{item.title}</h5><p>{item.desc}</p></div></div>
                                ))}
                            </div>
                        </div>
                        <div>
                            <h3 style={{ fontFamily: "'DM Serif Display', serif", marginBottom: "1.2rem" }}>{t.trace.certTitle}</h3>
                            <div style={styles.complianceFlags}>
                                {t.trace.flags.map((flag, i) => (
                                    <div key={i} className="flag-card" style={styles.flagCard}><h5>{flag.title}</h5><div style={styles.flagTags}>{flag.tags.map((tag, j) => (<span key={j} style={styles.flagTag}>{tag}</span>))}</div></div>
                                ))}
                            </div>
                            <div style={styles.certsGrid}>
                                {t.trace.certs.map((cert, i) => (
                                    <div key={i} className="cert-card" style={styles.certCard}><div style={styles.certIcon}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" /></svg></div><div style={styles.certName}>{cert.name}</div><div style={styles.certDetail}>{cert.detail}</div></div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>
                <div style={styles.divider}></div>

                {/* ESG */}
                <section id="esg" style={styles.section}>
                    <span style={styles.sectionEyebrow}>{t.esg.eyebrow}</span>
                    <h2 style={styles.sectionTitle}>
                        {t.esg.titleA}<span style={styles.heroEm}>{t.esg.titleEm}</span>
                        <br />{t.esg.titleB}
                    </h2>
                    <p style={styles.sectionLead}>{t.esg.lead}</p>

                    <div style={styles.esgTabsContainer}>
                        <div style={styles.esgTabs}>
                            {["env", "soc", "gov"].map((key, i) => (
                                <div key={key} onClick={() => setActiveESGTab(key)} className="esg-tab"
                                    style={{ ...styles.esgTab, ...(activeESGTab === key ? styles.activeEsgTab : {}) }}>
                                    {t.esg.tabs[i]}
                                </div>
                            ))}
                        </div>

                        {["env", "soc", "gov"].map((key) => (
                            <div key={key} style={activeESGTab === key ? { display: "flex", flexDirection: "column", gap: "1.25rem", marginTop: "2rem" } : { display: "none" }}>
                                {t.esg[key].map((item, idx) => (
                                    <div key={idx} style={{ display: "flex", alignItems: "flex-start", gap: "1.5rem", backgroundColor: "#faf9f8", borderRadius: "20px", padding: "1.2rem 1.5rem", transition: "transform 0.2s" }} className="esg-item-row">
                                        <div style={{ fontSize: "2.5rem", fontWeight: 700, color: "#a20000", opacity: 0.5, lineHeight: 1, minWidth: "60px" }}>
                                            {String(idx + 1).padStart(2, "0")}
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <h4 style={{ fontSize: "1.2rem", marginBottom: "0.4rem" }}>{item.title}</h4>
                                            <p style={{ color: "#555", lineHeight: 1.4, margin: 0 }}>{item.desc}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </section>

                {/* Factories */}
                <section id="factories" style={styles.section}>
                    <span style={{ ...styles.sectionEyebrow, color: "#a20000" }}>{t.factories.eyebrow}</span>
                    <h2 style={styles.sectionTitle}>{t.factories.titleA}<span style={{ color: "#a20000" }}>{t.factories.titleB}</span></h2>
                    <p style={styles.sectionLead}>{t.factories.lead}</p>
                    <div style={styles.factories}>
                        {t.factories.items.map((fac, i) => (
                            <div key={i} className="factory-card" style={{ ...styles.factoryCard }}><div style={styles.factoryNum}>{t.factories.factory} 0{i + 1}{i === 3 ? t.factories.upcoming : ""}</div><div style={styles.factoryName}>{fac[0]}</div><div style={styles.factoryLoc}>{fac[1]}</div><div style={styles.factoryCap}>{fac[2]}</div></div>
                        ))}
                    </div>
                </section>
            </div>
        </>
    );
};

export default EsgComp;